export interface Rgb {
  r: number;
  g: number;
  b: number;
}

export const validRgb = (input: unknown): Rgb => {
  const _x = input as globalThis.Record<string, unknown>;
  if (_x["r"] === undefined) throw new Error('`_x["r"]` required but not present');
  if (typeof _x["r"] !== 'number' || !Number.isSafeInteger(_x["r"] as number)) throw new Error('`_x["r"]` must be a safe integer');
  if (_x["g"] === undefined) throw new Error('`_x["g"]` required but not present');
  if (typeof _x["g"] !== 'number' || !Number.isSafeInteger(_x["g"] as number)) throw new Error('`_x["g"]` must be a safe integer');
  if (_x["b"] === undefined) throw new Error('`_x["b"]` required but not present');
  if (typeof _x["b"] !== 'number' || !Number.isSafeInteger(_x["b"] as number)) throw new Error('`_x["b"]` must be a safe integer');
  const x = input as Rgb;
  return x;
}
export const isValidRgb = (input: unknown): boolean => {
  try { validRgb(input); return true; } catch { return false; }
}

export interface ColorPalette {
  bg: Rgb;
  bgSecondary: Rgb;
  bgTertiary: Rgb;
  bgInput: Rgb;
  bgHover: Rgb;
  bgActive: Rgb;
  border: Rgb;
  borderStrong: Rgb;
  borderSubtle: Rgb;
  text: Rgb;
  textSecondary: Rgb;
  textTertiary: Rgb;
  textInverse: Rgb;
  accent: Rgb;
  accentDim: Rgb;
  accentSecondary: Rgb;
  danger: Rgb;
  warning: Rgb;
  info: Rgb;
  success: Rgb;
  muted: Rgb;
  synKeyword: Rgb;
  synString: Rgb;
  synNumber: Rgb;
  synComment: Rgb;
  synFunction: Rgb;
  synType: Rgb;
  synOperator: Rgb;
  synText: Rgb;
  synPunctuation: Rgb;
  synMeta: Rgb;
  synAtom: Rgb;
  synProperty: Rgb;
  synVariable: Rgb;
  scrollbarTrack: Rgb;
  scrollbarThumb: Rgb;
  scrollbarThumbHover: Rgb;
  ansiBlack: Rgb;
  ansiRed: Rgb;
  ansiGreen: Rgb;
  ansiYellow: Rgb;
  ansiBlue: Rgb;
  ansiMagenta: Rgb;
  ansiCyan: Rgb;
  ansiWhite: Rgb;
  ansiBlackBright: Rgb;
  ansiRedBright: Rgb;
  ansiGreenBright: Rgb;
  ansiYellowBright: Rgb;
  ansiBlueBright: Rgb;
  ansiMagentaBright: Rgb;
  ansiCyanBright: Rgb;
  ansiWhiteBright: Rgb;
}

export const validColorPalette = (input: unknown): ColorPalette => {
  const _x = input as globalThis.Record<string, unknown>;
  if (_x["bg"] === undefined) throw new Error('`_x["bg"]` required but not present');
  validRgb(_x["bg"] as any);
  if (_x["bgSecondary"] === undefined) throw new Error('`_x["bgSecondary"]` required but not present');
  validRgb(_x["bgSecondary"] as any);
  if (_x["bgTertiary"] === undefined) throw new Error('`_x["bgTertiary"]` required but not present');
  validRgb(_x["bgTertiary"] as any);
  if (_x["bgInput"] === undefined) throw new Error('`_x["bgInput"]` required but not present');
  validRgb(_x["bgInput"] as any);
  if (_x["bgHover"] === undefined) throw new Error('`_x["bgHover"]` required but not present');
  validRgb(_x["bgHover"] as any);
  if (_x["bgActive"] === undefined) throw new Error('`_x["bgActive"]` required but not present');
  validRgb(_x["bgActive"] as any);
  if (_x["border"] === undefined) throw new Error('`_x["border"]` required but not present');
  validRgb(_x["border"] as any);
  if (_x["borderStrong"] === undefined) throw new Error('`_x["borderStrong"]` required but not present');
  validRgb(_x["borderStrong"] as any);
  if (_x["borderSubtle"] === undefined) throw new Error('`_x["borderSubtle"]` required but not present');
  validRgb(_x["borderSubtle"] as any);
  if (_x["text"] === undefined) throw new Error('`_x["text"]` required but not present');
  validRgb(_x["text"] as any);
  if (_x["textSecondary"] === undefined) throw new Error('`_x["textSecondary"]` required but not present');
  validRgb(_x["textSecondary"] as any);
  if (_x["textTertiary"] === undefined) throw new Error('`_x["textTertiary"]` required but not present');
  validRgb(_x["textTertiary"] as any);
  if (_x["textInverse"] === undefined) throw new Error('`_x["textInverse"]` required but not present');
  validRgb(_x["textInverse"] as any);
  if (_x["accent"] === undefined) throw new Error('`_x["accent"]` required but not present');
  validRgb(_x["accent"] as any);
  if (_x["accentDim"] === undefined) throw new Error('`_x["accentDim"]` required but not present');
  validRgb(_x["accentDim"] as any);
  if (_x["accentSecondary"] === undefined) throw new Error('`_x["accentSecondary"]` required but not present');
  validRgb(_x["accentSecondary"] as any);
  if (_x["danger"] === undefined) throw new Error('`_x["danger"]` required but not present');
  validRgb(_x["danger"] as any);
  if (_x["warning"] === undefined) throw new Error('`_x["warning"]` required but not present');
  validRgb(_x["warning"] as any);
  if (_x["info"] === undefined) throw new Error('`_x["info"]` required but not present');
  validRgb(_x["info"] as any);
  if (_x["success"] === undefined) throw new Error('`_x["success"]` required but not present');
  validRgb(_x["success"] as any);
  if (_x["muted"] === undefined) throw new Error('`_x["muted"]` required but not present');
  validRgb(_x["muted"] as any);
  if (_x["synKeyword"] === undefined) throw new Error('`_x["synKeyword"]` required but not present');
  validRgb(_x["synKeyword"] as any);
  if (_x["synString"] === undefined) throw new Error('`_x["synString"]` required but not present');
  validRgb(_x["synString"] as any);
  if (_x["synNumber"] === undefined) throw new Error('`_x["synNumber"]` required but not present');
  validRgb(_x["synNumber"] as any);
  if (_x["synComment"] === undefined) throw new Error('`_x["synComment"]` required but not present');
  validRgb(_x["synComment"] as any);
  if (_x["synFunction"] === undefined) throw new Error('`_x["synFunction"]` required but not present');
  validRgb(_x["synFunction"] as any);
  if (_x["synType"] === undefined) throw new Error('`_x["synType"]` required but not present');
  validRgb(_x["synType"] as any);
  if (_x["synOperator"] === undefined) throw new Error('`_x["synOperator"]` required but not present');
  validRgb(_x["synOperator"] as any);
  if (_x["synText"] === undefined) throw new Error('`_x["synText"]` required but not present');
  validRgb(_x["synText"] as any);
  if (_x["synPunctuation"] === undefined) throw new Error('`_x["synPunctuation"]` required but not present');
  validRgb(_x["synPunctuation"] as any);
  if (_x["synMeta"] === undefined) throw new Error('`_x["synMeta"]` required but not present');
  validRgb(_x["synMeta"] as any);
  if (_x["synAtom"] === undefined) throw new Error('`_x["synAtom"]` required but not present');
  validRgb(_x["synAtom"] as any);
  if (_x["synProperty"] === undefined) throw new Error('`_x["synProperty"]` required but not present');
  validRgb(_x["synProperty"] as any);
  if (_x["synVariable"] === undefined) throw new Error('`_x["synVariable"]` required but not present');
  validRgb(_x["synVariable"] as any);
  if (_x["scrollbarTrack"] === undefined) throw new Error('`_x["scrollbarTrack"]` required but not present');
  validRgb(_x["scrollbarTrack"] as any);
  if (_x["scrollbarThumb"] === undefined) throw new Error('`_x["scrollbarThumb"]` required but not present');
  validRgb(_x["scrollbarThumb"] as any);
  if (_x["scrollbarThumbHover"] === undefined) throw new Error('`_x["scrollbarThumbHover"]` required but not present');
  validRgb(_x["scrollbarThumbHover"] as any);
  if (_x["ansiBlack"] === undefined) throw new Error('`_x["ansiBlack"]` required but not present');
  validRgb(_x["ansiBlack"] as any);
  if (_x["ansiRed"] === undefined) throw new Error('`_x["ansiRed"]` required but not present');
  validRgb(_x["ansiRed"] as any);
  if (_x["ansiGreen"] === undefined) throw new Error('`_x["ansiGreen"]` required but not present');
  validRgb(_x["ansiGreen"] as any);
  if (_x["ansiYellow"] === undefined) throw new Error('`_x["ansiYellow"]` required but not present');
  validRgb(_x["ansiYellow"] as any);
  if (_x["ansiBlue"] === undefined) throw new Error('`_x["ansiBlue"]` required but not present');
  validRgb(_x["ansiBlue"] as any);
  if (_x["ansiMagenta"] === undefined) throw new Error('`_x["ansiMagenta"]` required but not present');
  validRgb(_x["ansiMagenta"] as any);
  if (_x["ansiCyan"] === undefined) throw new Error('`_x["ansiCyan"]` required but not present');
  validRgb(_x["ansiCyan"] as any);
  if (_x["ansiWhite"] === undefined) throw new Error('`_x["ansiWhite"]` required but not present');
  validRgb(_x["ansiWhite"] as any);
  if (_x["ansiBlackBright"] === undefined) throw new Error('`_x["ansiBlackBright"]` required but not present');
  validRgb(_x["ansiBlackBright"] as any);
  if (_x["ansiRedBright"] === undefined) throw new Error('`_x["ansiRedBright"]` required but not present');
  validRgb(_x["ansiRedBright"] as any);
  if (_x["ansiGreenBright"] === undefined) throw new Error('`_x["ansiGreenBright"]` required but not present');
  validRgb(_x["ansiGreenBright"] as any);
  if (_x["ansiYellowBright"] === undefined) throw new Error('`_x["ansiYellowBright"]` required but not present');
  validRgb(_x["ansiYellowBright"] as any);
  if (_x["ansiBlueBright"] === undefined) throw new Error('`_x["ansiBlueBright"]` required but not present');
  validRgb(_x["ansiBlueBright"] as any);
  if (_x["ansiMagentaBright"] === undefined) throw new Error('`_x["ansiMagentaBright"]` required but not present');
  validRgb(_x["ansiMagentaBright"] as any);
  if (_x["ansiCyanBright"] === undefined) throw new Error('`_x["ansiCyanBright"]` required but not present');
  validRgb(_x["ansiCyanBright"] as any);
  if (_x["ansiWhiteBright"] === undefined) throw new Error('`_x["ansiWhiteBright"]` required but not present');
  validRgb(_x["ansiWhiteBright"] as any);
  const x = input as ColorPalette;
  return x;
}
export const isValidColorPalette = (input: unknown): boolean => {
  try { validColorPalette(input); return true; } catch { return false; }
}

export type Theme = "customDark" | "customLight" | "abcdef" | "abyss" | "androidStudio" | "andromeda" | "basicDark" | "basicLight" | "catppuccinMocha" | "cobalt2" | "forest" | "githubDark" | "githubLight" | "gruvboxDark" | "gruvboxLight" | "highContrastDark" | "highContrastLight" | "materialDark" | "materialLight" | "materialOcean" | "monokai" | "nord" | "palenight" | "solarizedDark" | "solarizedLight" | "synthwave84" | "tokyoNightDay" | "tokyoNightStorm" | "volcano" | "vscodeDark" | "vscodeLight"

export const validTheme = (x: unknown): Theme => {
  const v = x as [string, unknown] | string;
  if(((v != 'customDark')) && ((v != 'customLight')) && ((v != 'abcdef')) && ((v != 'abyss')) && ((v != 'androidStudio')) && ((v != 'andromeda')) && ((v != 'basicDark')) && ((v != 'basicLight')) && ((v != 'catppuccinMocha')) && ((v != 'cobalt2')) && ((v != 'forest')) && ((v != 'githubDark')) && ((v != 'githubLight')) && ((v != 'gruvboxDark')) && ((v != 'gruvboxLight')) && ((v != 'highContrastDark')) && ((v != 'highContrastLight')) && ((v != 'materialDark')) && ((v != 'materialLight')) && ((v != 'materialOcean')) && ((v != 'monokai')) && ((v != 'nord')) && ((v != 'palenight')) && ((v != 'solarizedDark')) && ((v != 'solarizedLight')) && ((v != 'synthwave84')) && ((v != 'tokyoNightDay')) && ((v != 'tokyoNightStorm')) && ((v != 'volcano')) && ((v != 'vscodeDark')) && ((v != 'vscodeLight'))) throw new Error('Invalid Theme `' + JSON.stringify(x) + '`');
  return x as Theme;
}

export type Font = "dejavuMono" | "jetbrainsMono" | "firaCode" | "ibmPlexMono" | "iosevka" | "cascadiaCode" | "hack" | "sourceCodePro"

export const validFont = (x: unknown): Font => {
  const v = x as [string, unknown] | string;
  if(((v != 'dejavuMono')) && ((v != 'jetbrainsMono')) && ((v != 'firaCode')) && ((v != 'ibmPlexMono')) && ((v != 'iosevka')) && ((v != 'cascadiaCode')) && ((v != 'hack')) && ((v != 'sourceCodePro'))) throw new Error('Invalid Font `' + JSON.stringify(x) + '`');
  return x as Font;
}

export type AdvancedColorMode = "derived" | "custom"

export const validAdvancedColorMode = (x: unknown): AdvancedColorMode => {
  const v = x as [string, unknown] | string;
  if(((v != 'derived')) && ((v != 'custom'))) throw new Error('Invalid AdvancedColorMode `' + JSON.stringify(x) + '`');
  return x as AdvancedColorMode;
}

export interface CustomPaletteEntry {
  cssVar: string;
  r: number;
  g: number;
  b: number;
}

export interface ApplyCustomPalettePayload {
  selector: string;
  entries: CustomPaletteEntry[];
}

export const validApplyCustomPalettePayload = (input: unknown): ApplyCustomPalettePayload => {
  const _x = input as globalThis.Record<string, unknown>;
  if (_x["selector"] === undefined) throw new Error('`_x["selector"]` required but not present');
  if (typeof _x["selector"] != 'string') throw new Error('`_x["selector"]` must be a string');
  if (_x["entries"] === undefined) throw new Error('`_x["entries"]` required but not present');
    if(_x["entries"] instanceof Array){
    if((_x["entries"] as any)?.length){
      (_x["entries"] as any).forEach((y: unknown) => {
         
  if (y === undefined) throw new Error('`y` required but not present');
  validCustomPaletteEntry(y as any);
      });
    }else{
      _x["entries"] = _x["entries"] === null ? null : [];
    }
  }else {
    throw new Error ('`_x["entries"]` must be an Array');
  }
  const x = input as ApplyCustomPalettePayload;
  return x;
}
export const isValidApplyCustomPalettePayload = (input: unknown): boolean => {
  try { validApplyCustomPalettePayload(input); return true; } catch { return false; }
}

export const illuminateTheme = (__x: Theme): string => {
  const tag = typeof __x === 'string' ? __x : __x[0];
  switch (tag) {
  case "customDark": {
  return "Custom Dark";
  }
  case "customLight": {
  return "Custom Light";
  }
  case "abcdef": {
  return "Abcdef";
  }
  case "abyss": {
  return "Abyss";
  }
  case "androidStudio": {
  return "Android Studio";
  }
  case "andromeda": {
  return "Andromeda";
  }
  case "basicDark": {
  return "Basic Dark";
  }
  case "basicLight": {
  return "Basic Light";
  }
  case "catppuccinMocha": {
  return "Catppuccin Mocha";
  }
  case "cobalt2": {
  return "Cobalt2";
  }
  case "forest": {
  return "Forest";
  }
  case "githubDark": {
  return "Github Dark";
  }
  case "githubLight": {
  return "Github Light";
  }
  case "gruvboxDark": {
  return "Gruvbox Dark";
  }
  case "gruvboxLight": {
  return "Gruvbox Light";
  }
  case "highContrastDark": {
  return "High Contrast Dark";
  }
  case "highContrastLight": {
  return "High Contrast Light";
  }
  case "materialDark": {
  return "Material Dark";
  }
  case "materialLight": {
  return "Material Light";
  }
  case "materialOcean": {
  return "Material Ocean";
  }
  case "monokai": {
  return "Monokai";
  }
  case "nord": {
  return "Nord";
  }
  case "palenight": {
  return "Palenight";
  }
  case "solarizedDark": {
  return "Solarized Dark";
  }
  case "solarizedLight": {
  return "Solarized Light";
  }
  case "synthwave84": {
  return "Synthwave 84";
  }
  case "tokyoNightDay": {
  return "Tokyo Night Day";
  }
  case "tokyoNightStorm": {
  return "Tokyo Night Storm";
  }
  case "volcano": {
  return "Volcano";
  }
  case "vscodeDark": {
  return "Vscode Dark";
  }
  case "vscodeLight": {
  return "Vscode Light";
  }
  }
}

export const illuminateFont = (__x: Font): string => {
  const tag = typeof __x === 'string' ? __x : __x[0];
  switch (tag) {
  case "dejavuMono": {
  return "DejaVu Mono";
  }
  case "jetbrainsMono": {
  return "JetBrains Mono";
  }
  case "firaCode": {
  return "Fira Code";
  }
  case "ibmPlexMono": {
  return "IBM Plex Mono";
  }
  case "iosevka": {
  return "Iosevka";
  }
  case "cascadiaCode": {
  return "Cascadia Code";
  }
  case "hack": {
  return "Hack";
  }
  case "sourceCodePro": {
  return "Source Code Pro";
  }
  }
}

export const illuminateAdvancedColorMode = (__x: AdvancedColorMode): string => {
  const tag = typeof __x === 'string' ? __x : __x[0];
  switch (tag) {
  case "derived": {
  return "Derived values";
  }
  case "custom": {
  return "Custom values";
  }
  }
}

export const validCustomPaletteEntry = (input: unknown): CustomPaletteEntry => {
  const _x = input as globalThis.Record<string, unknown>;
  if (_x["cssVar"] === undefined) throw new Error('`_x["cssVar"]` required but not present');
  if (typeof _x["cssVar"] != 'string') throw new Error('`_x["cssVar"]` must be a string');
  if (_x["r"] === undefined) throw new Error('`_x["r"]` required but not present');
  if (typeof _x["r"] !== 'number' || !Number.isSafeInteger(_x["r"] as number)) throw new Error('`_x["r"]` must be a safe integer');
  if (_x["g"] === undefined) throw new Error('`_x["g"]` required but not present');
  if (typeof _x["g"] !== 'number' || !Number.isSafeInteger(_x["g"] as number)) throw new Error('`_x["g"]` must be a safe integer');
  if (_x["b"] === undefined) throw new Error('`_x["b"]` required but not present');
  if (typeof _x["b"] !== 'number' || !Number.isSafeInteger(_x["b"] as number)) throw new Error('`_x["b"]` must be a safe integer');
  const x = input as CustomPaletteEntry;
  const errors: string[] = [];
  if ((x.r) < 0) errors.push(`RGB channel must be in 0..255`);
  if ((x.g) < 0) errors.push(`RGB channel must be in 0..255`);
  if ((x.b) < 0) errors.push(`RGB channel must be in 0..255`);
  if ((x.r) > 255) errors.push(`RGB channel must be in 0..255`);
  if ((x.g) > 255) errors.push(`RGB channel must be in 0..255`);
  if ((x.b) > 255) errors.push(`RGB channel must be in 0..255`);
  if (errors.length > 0) throw new Error(errors.join('; '));
  return x;
}
export const isValidCustomPaletteEntry = (input: unknown): boolean => {
  try { validCustomPaletteEntry(input); return true; } catch { return false; }
}

export const defaultPalette: ColorPalette =
  {
    'bg': {
      'r': 0,
      'g': 0,
      'b': 0,
    },
    'bgSecondary': {
      'r': 10,
      'g': 10,
      'b': 10,
    },
    'bgTertiary': {
      'r': 15,
      'g': 15,
      'b': 15,
    },
    'bgInput': {
      'r': 10,
      'g': 10,
      'b': 10,
    },
    'bgHover': {
      'r': 26,
      'g': 26,
      'b': 26,
    },
    'bgActive': {
      'r': 25,
      'g': 25,
      'b': 25,
    },
    'border': {
      'r': 25,
      'g': 25,
      'b': 25,
    },
    'borderStrong': {
      'r': 43,
      'g': 43,
      'b': 43,
    },
    'borderSubtle': {
      'r': 24,
      'g': 24,
      'b': 24,
    },
    'text': {
      'r': 224,
      'g': 224,
      'b': 224,
    },
    'textSecondary': {
      'r': 145,
      'g': 145,
      'b': 145,
    },
    'textTertiary': {
      'r': 119,
      'g': 119,
      'b': 119,
    },
    'textInverse': {
      'r': 255,
      'g': 255,
      'b': 255,
    },
    'accent': {
      'r': 0,
      'g': 112,
      'b': 255,
    },
    'accentDim': {
      'r': 0,
      'g': 89,
      'b': 204,
    },
    'accentSecondary': {
      'r': 169,
      'g': 220,
      'b': 118,
    },
    'danger': {
      'r': 255,
      'g': 51,
      'b': 51,
    },
    'warning': {
      'r': 255,
      'g': 170,
      'b': 0,
    },
    'info': {
      'r': 120,
      'g': 220,
      'b': 232,
    },
    'success': {
      'r': 255,
      'g': 216,
      'b': 102,
    },
    'muted': {
      'r': 42,
      'g': 42,
      'b': 42,
    },
    'synKeyword': {
      'r': 255,
      'g': 97,
      'b': 136,
    },
    'synString': {
      'r': 255,
      'g': 216,
      'b': 102,
    },
    'synNumber': {
      'r': 171,
      'g': 157,
      'b': 242,
    },
    'synComment': {
      'r': 85,
      'g': 85,
      'b': 85,
    },
    'synFunction': {
      'r': 169,
      'g': 220,
      'b': 118,
    },
    'synType': {
      'r': 120,
      'g': 220,
      'b': 232,
    },
    'synOperator': {
      'r': 255,
      'g': 97,
      'b': 136,
    },
    'synText': {
      'r': 224,
      'g': 224,
      'b': 224,
    },
    'synPunctuation': {
      'r': 136,
      'g': 136,
      'b': 136,
    },
    'synMeta': {
      'r': 179,
      'g': 136,
      'b': 255,
    },
    'synAtom': {
      'r': 171,
      'g': 157,
      'b': 242,
    },
    'synProperty': {
      'r': 120,
      'g': 220,
      'b': 232,
    },
    'synVariable': {
      'r': 0,
      'g': 191,
      'b': 255,
    },
    'scrollbarTrack': {
      'r': 10,
      'g': 10,
      'b': 10,
    },
    'scrollbarThumb': {
      'r': 25,
      'g': 25,
      'b': 25,
    },
    'scrollbarThumbHover': {
      'r': 43,
      'g': 43,
      'b': 43,
    },
    'ansiBlack': {
      'r': 15,
      'g': 15,
      'b': 15,
    },
    'ansiRed': {
      'r': 255,
      'g': 51,
      'b': 51,
    },
    'ansiGreen': {
      'r': 255,
      'g': 216,
      'b': 102,
    },
    'ansiYellow': {
      'r': 255,
      'g': 170,
      'b': 0,
    },
    'ansiBlue': {
      'r': 120,
      'g': 220,
      'b': 232,
    },
    'ansiMagenta': {
      'r': 169,
      'g': 220,
      'b': 118,
    },
    'ansiCyan': {
      'r': 60,
      'g': 166,
      'b': 243,
    },
    'ansiWhite': {
      'r': 145,
      'g': 145,
      'b': 145,
    },
    'ansiBlackBright': {
      'r': 77,
      'g': 77,
      'b': 77,
    },
    'ansiRedBright': {
      'r': 245,
      'g': 102,
      'b': 102,
    },
    'ansiGreenBright': {
      'r': 245,
      'g': 218,
      'b': 138,
    },
    'ansiYellowBright': {
      'r': 245,
      'g': 186,
      'b': 67,
    },
    'ansiBlueBright': {
      'r': 151,
      'g': 221,
      'b': 229,
    },
    'ansiMagentaBright': {
      'r': 185,
      'g': 221,
      'b': 149,
    },
    'ansiCyanBright': {
      'r': 109,
      'g': 183,
      'b': 237,
    },
    'ansiWhiteBright': {
      'r': 168,
      'g': 168,
      'b': 168,
    },
  }


export const customDarkPalette: ColorPalette =
  {
    'bg': {
      'r': 0,
      'g': 0,
      'b': 0,
    },
    'bgSecondary': {
      'r': 10,
      'g': 10,
      'b': 10,
    },
    'bgTertiary': {
      'r': 15,
      'g': 15,
      'b': 15,
    },
    'bgInput': {
      'r': 10,
      'g': 10,
      'b': 10,
    },
    'bgHover': {
      'r': 26,
      'g': 26,
      'b': 26,
    },
    'bgActive': {
      'r': 25,
      'g': 25,
      'b': 25,
    },
    'border': {
      'r': 25,
      'g': 25,
      'b': 25,
    },
    'borderStrong': {
      'r': 43,
      'g': 43,
      'b': 43,
    },
    'borderSubtle': {
      'r': 24,
      'g': 24,
      'b': 24,
    },
    'text': {
      'r': 224,
      'g': 224,
      'b': 224,
    },
    'textSecondary': {
      'r': 145,
      'g': 145,
      'b': 145,
    },
    'textTertiary': {
      'r': 119,
      'g': 119,
      'b': 119,
    },
    'textInverse': {
      'r': 255,
      'g': 255,
      'b': 255,
    },
    'accent': {
      'r': 0,
      'g': 112,
      'b': 255,
    },
    'accentDim': {
      'r': 0,
      'g': 89,
      'b': 204,
    },
    'accentSecondary': {
      'r': 169,
      'g': 220,
      'b': 118,
    },
    'danger': {
      'r': 255,
      'g': 51,
      'b': 51,
    },
    'warning': {
      'r': 255,
      'g': 170,
      'b': 0,
    },
    'info': {
      'r': 120,
      'g': 220,
      'b': 232,
    },
    'success': {
      'r': 255,
      'g': 216,
      'b': 102,
    },
    'muted': {
      'r': 42,
      'g': 42,
      'b': 42,
    },
    'synKeyword': {
      'r': 255,
      'g': 97,
      'b': 136,
    },
    'synString': {
      'r': 255,
      'g': 216,
      'b': 102,
    },
    'synNumber': {
      'r': 171,
      'g': 157,
      'b': 242,
    },
    'synComment': {
      'r': 85,
      'g': 85,
      'b': 85,
    },
    'synFunction': {
      'r': 169,
      'g': 220,
      'b': 118,
    },
    'synType': {
      'r': 120,
      'g': 220,
      'b': 232,
    },
    'synOperator': {
      'r': 255,
      'g': 97,
      'b': 136,
    },
    'synText': {
      'r': 224,
      'g': 224,
      'b': 224,
    },
    'synPunctuation': {
      'r': 136,
      'g': 136,
      'b': 136,
    },
    'synMeta': {
      'r': 179,
      'g': 136,
      'b': 255,
    },
    'synAtom': {
      'r': 171,
      'g': 157,
      'b': 242,
    },
    'synProperty': {
      'r': 120,
      'g': 220,
      'b': 232,
    },
    'synVariable': {
      'r': 0,
      'g': 191,
      'b': 255,
    },
    'scrollbarTrack': {
      'r': 10,
      'g': 10,
      'b': 10,
    },
    'scrollbarThumb': {
      'r': 25,
      'g': 25,
      'b': 25,
    },
    'scrollbarThumbHover': {
      'r': 43,
      'g': 43,
      'b': 43,
    },
    'ansiBlack': {
      'r': 15,
      'g': 15,
      'b': 15,
    },
    'ansiRed': {
      'r': 255,
      'g': 51,
      'b': 51,
    },
    'ansiGreen': {
      'r': 255,
      'g': 216,
      'b': 102,
    },
    'ansiYellow': {
      'r': 255,
      'g': 170,
      'b': 0,
    },
    'ansiBlue': {
      'r': 120,
      'g': 220,
      'b': 232,
    },
    'ansiMagenta': {
      'r': 169,
      'g': 220,
      'b': 118,
    },
    'ansiCyan': {
      'r': 60,
      'g': 166,
      'b': 243,
    },
    'ansiWhite': {
      'r': 145,
      'g': 145,
      'b': 145,
    },
    'ansiBlackBright': {
      'r': 77,
      'g': 77,
      'b': 77,
    },
    'ansiRedBright': {
      'r': 245,
      'g': 102,
      'b': 102,
    },
    'ansiGreenBright': {
      'r': 245,
      'g': 218,
      'b': 138,
    },
    'ansiYellowBright': {
      'r': 245,
      'g': 186,
      'b': 67,
    },
    'ansiBlueBright': {
      'r': 151,
      'g': 221,
      'b': 229,
    },
    'ansiMagentaBright': {
      'r': 185,
      'g': 221,
      'b': 149,
    },
    'ansiCyanBright': {
      'r': 109,
      'g': 183,
      'b': 237,
    },
    'ansiWhiteBright': {
      'r': 168,
      'g': 168,
      'b': 168,
    },
  }


export const customLightPalette: ColorPalette =
  {
    'bg': {
      'r': 255,
      'g': 255,
      'b': 255,
    },
    'bgSecondary': {
      'r': 240,
      'g': 244,
      'b': 248,
    },
    'bgTertiary': {
      'r': 244,
      'g': 244,
      'b': 244,
    },
    'bgInput': {
      'r': 249,
      'g': 249,
      'b': 249,
    },
    'bgHover': {
      'r': 240,
      'g': 244,
      'b': 248,
    },
    'bgActive': {
      'r': 239,
      'g': 239,
      'b': 239,
    },
    'border': {
      'r': 239,
      'g': 239,
      'b': 239,
    },
    'borderStrong': {
      'r': 227,
      'g': 227,
      'b': 227,
    },
    'borderSubtle': {
      'r': 239,
      'g': 239,
      'b': 239,
    },
    'text': {
      'r': 28,
      'g': 36,
      'b': 52,
    },
    'textSecondary': {
      'r': 107,
      'g': 112,
      'b': 123,
    },
    'textTertiary': {
      'r': 113,
      'g': 128,
      'b': 150,
    },
    'textInverse': {
      'r': 255,
      'g': 255,
      'b': 255,
    },
    'accent': {
      'r': 0,
      'g': 112,
      'b': 255,
    },
    'accentDim': {
      'r': 0,
      'g': 89,
      'b': 204,
    },
    'accentSecondary': {
      'r': 121,
      'g': 94,
      'b': 38,
    },
    'danger': {
      'r': 203,
      'g': 36,
      'b': 49,
    },
    'warning': {
      'r': 180,
      'g': 105,
      'b': 0,
    },
    'info': {
      'r': 38,
      'g': 127,
      'b': 153,
    },
    'success': {
      'r': 163,
      'g': 21,
      'b': 21,
    },
    'muted': {
      'r': 200,
      'g': 220,
      'b': 240,
    },
    'synKeyword': {
      'r': 175,
      'g': 0,
      'b': 219,
    },
    'synString': {
      'r': 163,
      'g': 21,
      'b': 21,
    },
    'synNumber': {
      'r': 9,
      'g': 134,
      'b': 88,
    },
    'synComment': {
      'r': 140,
      'g': 150,
      'b': 165,
    },
    'synFunction': {
      'r': 121,
      'g': 94,
      'b': 38,
    },
    'synType': {
      'r': 38,
      'g': 127,
      'b': 153,
    },
    'synOperator': {
      'r': 0,
      'g': 0,
      'b': 0,
    },
    'synText': {
      'r': 28,
      'g': 36,
      'b': 52,
    },
    'synPunctuation': {
      'r': 28,
      'g': 36,
      'b': 52,
    },
    'synMeta': {
      'r': 175,
      'g': 0,
      'b': 219,
    },
    'synAtom': {
      'r': 9,
      'g': 134,
      'b': 88,
    },
    'synProperty': {
      'r': 0,
      'g': 16,
      'b': 128,
    },
    'synVariable': {
      'r': 0,
      'g': 16,
      'b': 128,
    },
    'scrollbarTrack': {
      'r': 240,
      'g': 244,
      'b': 248,
    },
    'scrollbarThumb': {
      'r': 239,
      'g': 239,
      'b': 239,
    },
    'scrollbarThumbHover': {
      'r': 227,
      'g': 227,
      'b': 227,
    },
    'ansiBlack': {
      'r': 244,
      'g': 244,
      'b': 244,
    },
    'ansiRed': {
      'r': 203,
      'g': 36,
      'b': 49,
    },
    'ansiGreen': {
      'r': 163,
      'g': 21,
      'b': 21,
    },
    'ansiYellow': {
      'r': 180,
      'g': 105,
      'b': 0,
    },
    'ansiBlue': {
      'r': 38,
      'g': 127,
      'b': 153,
    },
    'ansiMagenta': {
      'r': 121,
      'g': 94,
      'b': 38,
    },
    'ansiCyan': {
      'r': 19,
      'g': 119,
      'b': 204,
    },
    'ansiWhite': {
      'r': 107,
      'g': 112,
      'b': 123,
    },
    'ansiBlackBright': {
      'r': 179,
      'g': 181,
      'b': 186,
    },
    'ansiRedBright': {
      'r': 150,
      'g': 36,
      'b': 49,
    },
    'ansiGreenBright': {
      'r': 122,
      'g': 25,
      'b': 30,
    },
    'ansiYellowBright': {
      'r': 134,
      'g': 84,
      'b': 15,
    },
    'ansiBlueBright': {
      'r': 35,
      'g': 99,
      'b': 122,
    },
    'ansiMagentaBright': {
      'r': 93,
      'g': 76,
      'b': 42,
    },
    'ansiCyanBright': {
      'r': 21,
      'g': 94,
      'b': 158,
    },
    'ansiWhiteBright': {
      'r': 83,
      'g': 89,
      'b': 101,
    },
  }


export const abcdefPalette: ColorPalette =
  {
    'bg': {
      'r': 10,
      'g': 14,
      'b': 20,
    },
    'bgSecondary': {
      'r': 36,
      'g': 41,
      'b': 54,
    },
    'bgTertiary': {
      'r': 24,
      'g': 28,
      'b': 34,
    },
    'bgInput': {
      'r': 19,
      'g': 23,
      'b': 29,
    },
    'bgHover': {
      'r': 58,
      'g': 74,
      'b': 95,
    },
    'bgActive': {
      'r': 34,
      'g': 38,
      'b': 43,
    },
    'border': {
      'r': 34,
      'g': 38,
      'b': 43,
    },
    'borderStrong': {
      'r': 51,
      'g': 55,
      'b': 59,
    },
    'borderSubtle': {
      'r': 32,
      'g': 36,
      'b': 41,
    },
    'text': {
      'r': 224,
      'g': 237,
      'b': 255,
    },
    'textSecondary': {
      'r': 149,
      'g': 158,
      'b': 172,
    },
    'textTertiary': {
      'r': 216,
      'g': 225,
      'b': 240,
    },
    'textInverse': {
      'r': 0,
      'g': 0,
      'b': 0,
    },
    'accent': {
      'r': 239,
      'g': 187,
      'b': 36,
    },
    'accentDim': {
      'r': 191,
      'g': 149,
      'b': 28,
    },
    'accentSecondary': {
      'r': 255,
      'g': 238,
      'b': 153,
    },
    'danger': {
      'r': 255,
      'g': 83,
      'b': 112,
    },
    'warning': {
      'r': 239,
      'g': 187,
      'b': 36,
    },
    'info': {
      'r': 255,
      'g': 204,
      'b': 68,
    },
    'success': {
      'r': 122,
      'g': 236,
      'b': 179,
    },
    'muted': {
      'r': 58,
      'g': 74,
      'b': 95,
    },
    'synKeyword': {
      'r': 239,
      'g': 187,
      'b': 36,
    },
    'synString': {
      'r': 122,
      'g': 236,
      'b': 179,
    },
    'synNumber': {
      'r': 199,
      'g': 146,
      'b': 234,
    },
    'synComment': {
      'r': 140,
      'g': 143,
      'b': 147,
    },
    'synFunction': {
      'r': 255,
      'g': 238,
      'b': 153,
    },
    'synType': {
      'r': 255,
      'g': 204,
      'b': 68,
    },
    'synOperator': {
      'r': 255,
      'g': 156,
      'b': 172,
    },
    'synText': {
      'r': 224,
      'g': 237,
      'b': 255,
    },
    'synPunctuation': {
      'r': 208,
      'g': 214,
      'b': 224,
    },
    'synMeta': {
      'r': 120,
      'g': 160,
      'b': 211,
    },
    'synAtom': {
      'r': 199,
      'g': 146,
      'b': 234,
    },
    'synProperty': {
      'r': 171,
      'g': 205,
      'b': 239,
    },
    'synVariable': {
      'r': 119,
      'g': 153,
      'b': 255,
    },
    'scrollbarTrack': {
      'r': 36,
      'g': 41,
      'b': 54,
    },
    'scrollbarThumb': {
      'r': 34,
      'g': 38,
      'b': 43,
    },
    'scrollbarThumbHover': {
      'r': 51,
      'g': 55,
      'b': 59,
    },
    'ansiBlack': {
      'r': 24,
      'g': 28,
      'b': 34,
    },
    'ansiRed': {
      'r': 255,
      'g': 83,
      'b': 112,
    },
    'ansiGreen': {
      'r': 122,
      'g': 236,
      'b': 179,
    },
    'ansiYellow': {
      'r': 239,
      'g': 187,
      'b': 36,
    },
    'ansiBlue': {
      'r': 255,
      'g': 204,
      'b': 68,
    },
    'ansiMagenta': {
      'r': 255,
      'g': 238,
      'b': 153,
    },
    'ansiCyan': {
      'r': 247,
      'g': 195,
      'b': 52,
    },
    'ansiWhite': {
      'r': 149,
      'g': 158,
      'b': 172,
    },
    'ansiBlackBright': {
      'r': 84,
      'g': 90,
      'b': 100,
    },
    'ansiRedBright': {
      'r': 245,
      'g': 129,
      'b': 154,
    },
    'ansiGreenBright': {
      'r': 152,
      'g': 236,
      'b': 201,
    },
    'ansiYellowBright': {
      'r': 234,
      'g': 202,
      'b': 101,
    },
    'ansiBlueBright': {
      'r': 245,
      'g': 213,
      'b': 124,
    },
    'ansiMagentaBright': {
      'r': 245,
      'g': 237,
      'b': 183,
    },
    'ansiCyanBright': {
      'r': 240,
      'g': 207,
      'b': 112,
    },
    'ansiWhiteBright': {
      'r': 171,
      'g': 181,
      'b': 196,
    },
  }


export const abyssPalette: ColorPalette =
  {
    'bg': {
      'r': 0,
      'g': 12,
      'b': 24,
    },
    'bgSecondary': {
      'r': 10,
      'g': 20,
      'b': 34,
    },
    'bgTertiary': {
      'r': 15,
      'g': 26,
      'b': 37,
    },
    'bgInput': {
      'r': 10,
      'g': 21,
      'b': 33,
    },
    'bgHover': {
      'r': 0,
      'g': 85,
      'b': 255,
    },
    'bgActive': {
      'r': 25,
      'g': 36,
      'b': 47,
    },
    'border': {
      'r': 25,
      'g': 36,
      'b': 47,
    },
    'borderStrong': {
      'r': 43,
      'g': 53,
      'b': 63,
    },
    'borderSubtle': {
      'r': 24,
      'g': 34,
      'b': 45,
    },
    'text': {
      'r': 163,
      'g': 201,
      'b': 233,
    },
    'textSecondary': {
      'r': 105,
      'g': 134,
      'b': 159,
    },
    'textTertiary': {
      'r': 95,
      'g': 126,
      'b': 151,
    },
    'textInverse': {
      'r': 0,
      'g': 0,
      'b': 0,
    },
    'accent': {
      'r': 71,
      'g': 193,
      'b': 255,
    },
    'accentDim': {
      'r': 56,
      'g': 154,
      'b': 204,
    },
    'accentSecondary': {
      'r': 195,
      'g': 162,
      'b': 247,
    },
    'danger': {
      'r': 255,
      'g': 83,
      'b': 112,
    },
    'warning': {
      'r': 76,
      'g': 230,
      'b': 96,
    },
    'info': {
      'r': 180,
      'g': 162,
      'b': 247,
    },
    'success': {
      'r': 76,
      'g': 230,
      'b': 96,
    },
    'muted': {
      'r': 14,
      'g': 98,
      'b': 153,
    },
    'synKeyword': {
      'r': 71,
      'g': 193,
      'b': 255,
    },
    'synString': {
      'r': 76,
      'g': 230,
      'b': 96,
    },
    'synNumber': {
      'r': 255,
      'g': 158,
      'b': 234,
    },
    'synComment': {
      'r': 117,
      'g': 153,
      'b': 194,
    },
    'synFunction': {
      'r': 195,
      'g': 162,
      'b': 247,
    },
    'synType': {
      'r': 180,
      'g': 162,
      'b': 247,
    },
    'synOperator': {
      'r': 120,
      'g': 182,
      'b': 255,
    },
    'synText': {
      'r': 163,
      'g': 201,
      'b': 233,
    },
    'synPunctuation': {
      'r': 141,
      'g': 160,
      'b': 191,
    },
    'synMeta': {
      'r': 117,
      'g': 153,
      'b': 194,
    },
    'synAtom': {
      'r': 255,
      'g': 158,
      'b': 100,
    },
    'synProperty': {
      'r': 142,
      'g': 184,
      'b': 255,
    },
    'synVariable': {
      'r': 122,
      'g': 178,
      'b': 255,
    },
    'scrollbarTrack': {
      'r': 10,
      'g': 20,
      'b': 34,
    },
    'scrollbarThumb': {
      'r': 25,
      'g': 36,
      'b': 47,
    },
    'scrollbarThumbHover': {
      'r': 43,
      'g': 53,
      'b': 63,
    },
    'ansiBlack': {
      'r': 15,
      'g': 26,
      'b': 37,
    },
    'ansiRed': {
      'r': 255,
      'g': 83,
      'b': 112,
    },
    'ansiGreen': {
      'r': 76,
      'g': 230,
      'b': 96,
    },
    'ansiYellow': {
      'r': 97,
      'g': 233,
      'b': 115,
    },
    'ansiBlue': {
      'r': 180,
      'g': 162,
      'b': 247,
    },
    'ansiMagenta': {
      'r': 195,
      'g': 162,
      'b': 247,
    },
    'ansiCyan': {
      'r': 125,
      'g': 177,
      'b': 251,
    },
    'ansiWhite': {
      'r': 105,
      'g': 134,
      'b': 159,
    },
    'ansiBlackBright': {
      'r': 59,
      'g': 78,
      'b': 95,
    },
    'ansiRedBright': {
      'r': 227,
      'g': 118,
      'b': 148,
    },
    'ansiGreenBright': {
      'r': 102,
      'g': 221,
      'b': 137,
    },
    'ansiYellowBright': {
      'r': 116,
      'g': 223,
      'b': 150,
    },
    'ansiBlueBright': {
      'r': 174,
      'g': 173,
      'b': 242,
    },
    'ansiMagentaBright': {
      'r': 185,
      'g': 173,
      'b': 242,
    },
    'ansiCyanBright': {
      'r': 136,
      'g': 184,
      'b': 245,
    },
    'ansiWhiteBright': {
      'r': 122,
      'g': 154,
      'b': 181,
    },
  }


export const androidStudioPalette: ColorPalette =
  {
    'bg': {
      'r': 40,
      'g': 43,
      'b': 46,
    },
    'bgSecondary': {
      'r': 49,
      'g': 51,
      'b': 53,
    },
    'bgTertiary': {
      'r': 52,
      'g': 55,
      'b': 58,
    },
    'bgInput': {
      'r': 48,
      'g': 51,
      'b': 54,
    },
    'bgHover': {
      'r': 50,
      'g': 50,
      'b': 50,
    },
    'bgActive': {
      'r': 61,
      'g': 64,
      'b': 66,
    },
    'border': {
      'r': 61,
      'g': 64,
      'b': 66,
    },
    'borderStrong': {
      'r': 76,
      'g': 79,
      'b': 81,
    },
    'borderSubtle': {
      'r': 58,
      'g': 61,
      'b': 63,
    },
    'text': {
      'r': 169,
      'g': 183,
      'b': 198,
    },
    'textSecondary': {
      'r': 123,
      'g': 134,
      'b': 144,
    },
    'textTertiary': {
      'r': 96,
      'g': 99,
      'b': 102,
    },
    'textInverse': {
      'r': 255,
      'g': 255,
      'b': 255,
    },
    'accent': {
      'r': 204,
      'g': 120,
      'b': 50,
    },
    'accentDim': {
      'r': 163,
      'g': 96,
      'b': 40,
    },
    'accentSecondary': {
      'r': 169,
      'g': 183,
      'b': 198,
    },
    'danger': {
      'r': 255,
      'g': 83,
      'b': 83,
    },
    'warning': {
      'r': 232,
      'g': 191,
      'b': 106,
    },
    'info': {
      'r': 255,
      'g': 198,
      'b': 109,
    },
    'success': {
      'r': 106,
      'g': 135,
      'b': 89,
    },
    'muted': {
      'r': 46,
      'g': 82,
      'b': 128,
    },
    'synKeyword': {
      'r': 204,
      'g': 120,
      'b': 50,
    },
    'synString': {
      'r': 106,
      'g': 135,
      'b': 89,
    },
    'synNumber': {
      'r': 104,
      'g': 151,
      'b': 187,
    },
    'synComment': {
      'r': 120,
      'g': 120,
      'b': 120,
    },
    'synFunction': {
      'r': 169,
      'g': 183,
      'b': 198,
    },
    'synType': {
      'r': 255,
      'g': 198,
      'b': 109,
    },
    'synOperator': {
      'r': 204,
      'g': 120,
      'b': 50,
    },
    'synText': {
      'r': 169,
      'g': 183,
      'b': 198,
    },
    'synPunctuation': {
      'r': 169,
      'g': 183,
      'b': 198,
    },
    'synMeta': {
      'r': 120,
      'g': 120,
      'b': 120,
    },
    'synAtom': {
      'r': 204,
      'g': 120,
      'b': 50,
    },
    'synProperty': {
      'r': 106,
      'g': 135,
      'b': 89,
    },
    'synVariable': {
      'r': 152,
      'g': 118,
      'b': 170,
    },
    'scrollbarTrack': {
      'r': 49,
      'g': 51,
      'b': 53,
    },
    'scrollbarThumb': {
      'r': 61,
      'g': 64,
      'b': 66,
    },
    'scrollbarThumbHover': {
      'r': 76,
      'g': 79,
      'b': 81,
    },
    'ansiBlack': {
      'r': 52,
      'g': 55,
      'b': 58,
    },
    'ansiRed': {
      'r': 255,
      'g': 83,
      'b': 83,
    },
    'ansiGreen': {
      'r': 106,
      'g': 135,
      'b': 89,
    },
    'ansiYellow': {
      'r': 232,
      'g': 191,
      'b': 106,
    },
    'ansiBlue': {
      'r': 255,
      'g': 198,
      'b': 109,
    },
    'ansiMagenta': {
      'r': 169,
      'g': 183,
      'b': 198,
    },
    'ansiCyan': {
      'r': 229,
      'g': 159,
      'b': 79,
    },
    'ansiWhite': {
      'r': 123,
      'g': 134,
      'b': 144,
    },
    'ansiBlackBright': {
      'r': 87,
      'g': 93,
      'b': 100,
    },
    'ansiRedBright': {
      'r': 229,
      'g': 113,
      'b': 117,
    },
    'ansiGreenBright': {
      'r': 124,
      'g': 149,
      'b': 121,
    },
    'ansiYellowBright': {
      'r': 213,
      'g': 188,
      'b': 133,
    },
    'ansiBlueBright': {
      'r': 229,
      'g': 193,
      'b': 135,
    },
    'ansiMagentaBright': {
      'r': 179,
      'g': 191,
      'b': 204,
    },
    'ansiCyanBright': {
      'r': 210,
      'g': 166,
      'b': 114,
    },
    'ansiWhiteBright': {
      'r': 136,
      'g': 148,
      'b': 160,
    },
  }


export const andromedaPalette: ColorPalette =
  {
    'bg': {
      'r': 27,
      'g': 30,
      'b': 38,
    },
    'bgSecondary': {
      'r': 36,
      'g': 40,
      'b': 48,
    },
    'bgTertiary': {
      'r': 40,
      'g': 43,
      'b': 51,
    },
    'bgInput': {
      'r': 36,
      'g': 39,
      'b': 46,
    },
    'bgHover': {
      'r': 48,
      'g': 52,
      'b': 61,
    },
    'bgActive': {
      'r': 49,
      'g': 52,
      'b': 59,
    },
    'border': {
      'r': 49,
      'g': 52,
      'b': 59,
    },
    'borderStrong': {
      'r': 65,
      'g': 68,
      'b': 74,
    },
    'borderSubtle': {
      'r': 47,
      'g': 49,
      'b': 56,
    },
    'text': {
      'r': 228,
      'g': 223,
      'b': 240,
    },
    'textSecondary': {
      'r': 157,
      'g': 155,
      'b': 169,
    },
    'textTertiary': {
      'r': 116,
      'g': 128,
      'b': 153,
    },
    'textInverse': {
      'r': 0,
      'g': 0,
      'b': 0,
    },
    'accent': {
      'r': 214,
      'g': 103,
      'b': 255,
    },
    'accentDim': {
      'r': 171,
      'g': 82,
      'b': 204,
    },
    'accentSecondary': {
      'r': 255,
      'g': 221,
      'b': 128,
    },
    'danger': {
      'r': 255,
      'g': 49,
      'b': 98,
    },
    'warning': {
      'r': 255,
      'g': 221,
      'b': 128,
    },
    'info': {
      'r': 255,
      'g': 221,
      'b': 128,
    },
    'success': {
      'r': 166,
      'g': 224,
      'b': 122,
    },
    'muted': {
      'r': 219,
      'g': 69,
      'b': 162,
    },
    'synKeyword': {
      'r': 214,
      'g': 103,
      'b': 255,
    },
    'synString': {
      'r': 166,
      'g': 224,
      'b': 122,
    },
    'synNumber': {
      'r': 255,
      'g': 112,
      'b': 87,
    },
    'synComment': {
      'r': 168,
      'g': 170,
      'b': 185,
    },
    'synFunction': {
      'r': 255,
      'g': 221,
      'b': 128,
    },
    'synType': {
      'r': 255,
      'g': 221,
      'b': 128,
    },
    'synOperator': {
      'r': 199,
      'g': 199,
      'b': 255,
    },
    'synText': {
      'r': 228,
      'g': 223,
      'b': 240,
    },
    'synPunctuation': {
      'r': 199,
      'g': 199,
      'b': 255,
    },
    'synMeta': {
      'r': 168,
      'g': 170,
      'b': 185,
    },
    'synAtom': {
      'r': 255,
      'g': 112,
      'b': 87,
    },
    'synProperty': {
      'r': 36,
      'g': 227,
      'b': 195,
    },
    'synVariable': {
      'r': 36,
      'g': 227,
      'b': 195,
    },
    'scrollbarTrack': {
      'r': 36,
      'g': 40,
      'b': 48,
    },
    'scrollbarThumb': {
      'r': 49,
      'g': 52,
      'b': 59,
    },
    'scrollbarThumbHover': {
      'r': 65,
      'g': 68,
      'b': 74,
    },
    'ansiBlack': {
      'r': 40,
      'g': 43,
      'b': 51,
    },
    'ansiRed': {
      'r': 255,
      'g': 49,
      'b': 98,
    },
    'ansiGreen': {
      'r': 166,
      'g': 224,
      'b': 122,
    },
    'ansiYellow': {
      'r': 255,
      'g': 221,
      'b': 128,
    },
    'ansiBlue': {
      'r': 255,
      'g': 225,
      'b': 143,
    },
    'ansiMagenta': {
      'r': 255,
      'g': 228,
      'b': 156,
    },
    'ansiCyan': {
      'r': 234,
      'g': 162,
      'b': 191,
    },
    'ansiWhite': {
      'r': 157,
      'g': 155,
      'b': 169,
    },
    'ansiBlackBright': {
      'r': 96,
      'g': 96,
      'b': 107,
    },
    'ansiRedBright': {
      'r': 246,
      'g': 101,
      'b': 140,
    },
    'ansiGreenBright': {
      'r': 184,
      'g': 223,
      'b': 157,
    },
    'ansiYellowBright': {
      'r': 246,
      'g': 221,
      'b': 161,
    },
    'ansiBlueBright': {
      'r': 246,
      'g': 224,
      'b': 172,
    },
    'ansiMagentaBright': {
      'r': 246,
      'g': 226,
      'b': 181,
    },
    'ansiCyanBright': {
      'r': 232,
      'g': 180,
      'b': 205,
    },
    'ansiWhiteBright': {
      'r': 178,
      'g': 175,
      'b': 190,
    },
  }


export const basicDarkPalette: ColorPalette =
  {
    'bg': {
      'r': 30,
      'g': 33,
      'b': 36,
    },
    'bgSecondary': {
      'r': 37,
      'g': 37,
      'b': 41,
    },
    'bgTertiary': {
      'r': 43,
      'g': 46,
      'b': 49,
    },
    'bgInput': {
      'r': 39,
      'g': 41,
      'b': 44,
    },
    'bgHover': {
      'r': 58,
      'g': 61,
      'b': 65,
    },
    'bgActive': {
      'r': 52,
      'g': 55,
      'b': 57,
    },
    'border': {
      'r': 52,
      'g': 55,
      'b': 57,
    },
    'borderStrong': {
      'r': 68,
      'g': 71,
      'b': 72,
    },
    'borderSubtle': {
      'r': 49,
      'g': 52,
      'b': 54,
    },
    'text': {
      'r': 226,
      'g': 226,
      'b': 226,
    },
    'textSecondary': {
      'r': 157,
      'g': 158,
      'b': 159,
    },
    'textTertiary': {
      'r': 144,
      'g': 144,
      'b': 144,
    },
    'textInverse': {
      'r': 0,
      'g': 0,
      'b': 0,
    },
    'accent': {
      'r': 255,
      'g': 203,
      'b': 107,
    },
    'accentDim': {
      'r': 204,
      'g': 162,
      'b': 85,
    },
    'accentSecondary': {
      'r': 97,
      'g': 175,
      'b': 239,
    },
    'danger': {
      'r': 224,
      'g': 108,
      'b': 117,
    },
    'warning': {
      'r': 255,
      'g': 203,
      'b': 107,
    },
    'info': {
      'r': 86,
      'g': 182,
      'b': 194,
    },
    'success': {
      'r': 152,
      'g': 195,
      'b': 121,
    },
    'muted': {
      'r': 58,
      'g': 89,
      'b': 145,
    },
    'synKeyword': {
      'r': 255,
      'g': 203,
      'b': 107,
    },
    'synString': {
      'r': 152,
      'g': 195,
      'b': 121,
    },
    'synNumber': {
      'r': 243,
      'g': 156,
      'b': 18,
    },
    'synComment': {
      'r': 144,
      'g': 144,
      'b': 144,
    },
    'synFunction': {
      'r': 97,
      'g': 175,
      'b': 239,
    },
    'synType': {
      'r': 86,
      'g': 182,
      'b': 194,
    },
    'synOperator': {
      'r': 198,
      'g': 120,
      'b': 221,
    },
    'synText': {
      'r': 226,
      'g': 226,
      'b': 226,
    },
    'synPunctuation': {
      'r': 198,
      'g': 120,
      'b': 221,
    },
    'synMeta': {
      'r': 224,
      'g': 108,
      'b': 117,
    },
    'synAtom': {
      'r': 243,
      'g': 156,
      'b': 18,
    },
    'synProperty': {
      'r': 86,
      'g': 182,
      'b': 194,
    },
    'synVariable': {
      'r': 97,
      'g': 175,
      'b': 239,
    },
    'scrollbarTrack': {
      'r': 37,
      'g': 37,
      'b': 41,
    },
    'scrollbarThumb': {
      'r': 52,
      'g': 55,
      'b': 57,
    },
    'scrollbarThumbHover': {
      'r': 68,
      'g': 71,
      'b': 72,
    },
    'ansiBlack': {
      'r': 43,
      'g': 46,
      'b': 49,
    },
    'ansiRed': {
      'r': 224,
      'g': 108,
      'b': 117,
    },
    'ansiGreen': {
      'r': 152,
      'g': 195,
      'b': 121,
    },
    'ansiYellow': {
      'r': 255,
      'g': 203,
      'b': 107,
    },
    'ansiBlue': {
      'r': 86,
      'g': 182,
      'b': 194,
    },
    'ansiMagenta': {
      'r': 97,
      'g': 175,
      'b': 239,
    },
    'ansiCyan': {
      'r': 170,
      'g': 192,
      'b': 150,
    },
    'ansiWhite': {
      'r': 157,
      'g': 158,
      'b': 159,
    },
    'ansiBlackBright': {
      'r': 97,
      'g': 100,
      'b': 102,
    },
    'ansiRedBright': {
      'r': 224,
      'g': 143,
      'b': 149,
    },
    'ansiGreenBright': {
      'r': 174,
      'g': 204,
      'b': 152,
    },
    'ansiYellowBright': {
      'r': 246,
      'g': 209,
      'b': 142,
    },
    'ansiBlueBright': {
      'r': 128,
      'g': 195,
      'b': 203,
    },
    'ansiMagentaBright': {
      'r': 135,
      'g': 190,
      'b': 235,
    },
    'ansiCyanBright': {
      'r': 186,
      'g': 202,
      'b': 172,
    },
    'ansiWhiteBright': {
      'r': 177,
      'g': 178,
      'b': 179,
    },
  }


export const basicLightPalette: ColorPalette =
  {
    'bg': {
      'r': 255,
      'g': 255,
      'b': 255,
    },
    'bgSecondary': {
      'r': 240,
      'g': 244,
      'b': 248,
    },
    'bgTertiary': {
      'r': 244,
      'g': 244,
      'b': 244,
    },
    'bgInput': {
      'r': 249,
      'g': 249,
      'b': 249,
    },
    'bgHover': {
      'r': 235,
      'g': 244,
      'b': 255,
    },
    'bgActive': {
      'r': 239,
      'g': 239,
      'b': 239,
    },
    'border': {
      'r': 239,
      'g': 239,
      'b': 239,
    },
    'borderStrong': {
      'r': 227,
      'g': 227,
      'b': 227,
    },
    'borderSubtle': {
      'r': 239,
      'g': 239,
      'b': 239,
    },
    'text': {
      'r': 28,
      'g': 36,
      'b': 52,
    },
    'textSecondary': {
      'r': 107,
      'g': 112,
      'b': 123,
    },
    'textTertiary': {
      'r': 74,
      'g': 85,
      'b': 104,
    },
    'textInverse': {
      'r': 255,
      'g': 255,
      'b': 255,
    },
    'accent': {
      'r': 3,
      'g': 105,
      'b': 161,
    },
    'accentDim': {
      'r': 2,
      'g': 84,
      'b': 128,
    },
    'accentSecondary': {
      'r': 3,
      'g': 105,
      'b': 161,
    },
    'danger': {
      'r': 229,
      'g': 62,
      'b': 62,
    },
    'warning': {
      'r': 214,
      'g': 158,
      'b': 46,
    },
    'info': {
      'r': 214,
      'g': 158,
      'b': 46,
    },
    'success': {
      'r': 221,
      'g': 107,
      'b': 32,
    },
    'muted': {
      'r': 144,
      'g': 205,
      'b': 244,
    },
    'synKeyword': {
      'r': 26,
      'g': 54,
      'b': 93,
    },
    'synString': {
      'r': 221,
      'g': 107,
      'b': 32,
    },
    'synNumber': {
      'r': 3,
      'g': 105,
      'b': 161,
    },
    'synComment': {
      'r': 113,
      'g': 128,
      'b': 150,
    },
    'synFunction': {
      'r': 3,
      'g': 105,
      'b': 161,
    },
    'synType': {
      'r': 214,
      'g': 158,
      'b': 46,
    },
    'synOperator': {
      'r': 47,
      'g': 133,
      'b': 90,
    },
    'synText': {
      'r': 28,
      'g': 36,
      'b': 52,
    },
    'synPunctuation': {
      'r': 12,
      'g': 119,
      'b': 146,
    },
    'synMeta': {
      'r': 3,
      'g': 105,
      'b': 161,
    },
    'synAtom': {
      'r': 221,
      'g': 107,
      'b': 32,
    },
    'synProperty': {
      'r': 43,
      'g': 108,
      'b': 176,
    },
    'synVariable': {
      'r': 43,
      'g': 108,
      'b': 176,
    },
    'scrollbarTrack': {
      'r': 240,
      'g': 244,
      'b': 248,
    },
    'scrollbarThumb': {
      'r': 239,
      'g': 239,
      'b': 239,
    },
    'scrollbarThumbHover': {
      'r': 227,
      'g': 227,
      'b': 227,
    },
    'ansiBlack': {
      'r': 244,
      'g': 244,
      'b': 244,
    },
    'ansiRed': {
      'r': 229,
      'g': 62,
      'b': 62,
    },
    'ansiGreen': {
      'r': 221,
      'g': 107,
      'b': 32,
    },
    'ansiYellow': {
      'r': 214,
      'g': 158,
      'b': 46,
    },
    'ansiBlue': {
      'r': 188,
      'g': 139,
      'b': 40,
    },
    'ansiMagenta': {
      'r': 3,
      'g': 105,
      'b': 161,
    },
    'ansiCyan': {
      'r': 108,
      'g': 131,
      'b': 103,
    },
    'ansiWhite': {
      'r': 107,
      'g': 112,
      'b': 123,
    },
    'ansiBlackBright': {
      'r': 179,
      'g': 181,
      'b': 186,
    },
    'ansiRedBright': {
      'r': 168,
      'g': 54,
      'b': 59,
    },
    'ansiGreenBright': {
      'r': 163,
      'g': 85,
      'b': 38,
    },
    'ansiYellowBright': {
      'r': 158,
      'g': 121,
      'b': 47,
    },
    'ansiBlueBright': {
      'r': 140,
      'g': 108,
      'b': 43,
    },
    'ansiMagentaBright': {
      'r': 10,
      'g': 84,
      'b': 128,
    },
    'ansiCyanBright': {
      'r': 84,
      'g': 102,
      'b': 87,
    },
    'ansiWhiteBright': {
      'r': 83,
      'g': 89,
      'b': 101,
    },
  }


export const catppuccinMochaPalette: ColorPalette =
  {
    'bg': {
      'r': 30,
      'g': 30,
      'b': 46,
    },
    'bgSecondary': {
      'r': 24,
      'g': 24,
      'b': 37,
    },
    'bgTertiary': {
      'r': 43,
      'g': 43,
      'b': 58,
    },
    'bgInput': {
      'r': 39,
      'g': 39,
      'b': 54,
    },
    'bgHover': {
      'r': 58,
      'g': 58,
      'b': 82,
    },
    'bgActive': {
      'r': 52,
      'g': 52,
      'b': 66,
    },
    'border': {
      'r': 52,
      'g': 52,
      'b': 66,
    },
    'borderStrong': {
      'r': 68,
      'g': 68,
      'b': 81,
    },
    'borderSubtle': {
      'r': 49,
      'g': 49,
      'b': 63,
    },
    'text': {
      'r': 205,
      'g': 214,
      'b': 244,
    },
    'textSecondary': {
      'r': 143,
      'g': 149,
      'b': 174,
    },
    'textTertiary': {
      'r': 69,
      'g': 71,
      'b': 90,
    },
    'textInverse': {
      'r': 0,
      'g': 0,
      'b': 0,
    },
    'accent': {
      'r': 137,
      'g': 180,
      'b': 250,
    },
    'accentDim': {
      'r': 109,
      'g': 144,
      'b': 200,
    },
    'accentSecondary': {
      'r': 137,
      'g': 180,
      'b': 250,
    },
    'danger': {
      'r': 243,
      'g': 139,
      'b': 168,
    },
    'warning': {
      'r': 249,
      'g': 226,
      'b': 175,
    },
    'info': {
      'r': 249,
      'g': 226,
      'b': 175,
    },
    'success': {
      'r': 166,
      'g': 227,
      'b': 161,
    },
    'muted': {
      'r': 88,
      'g': 91,
      'b': 112,
    },
    'synKeyword': {
      'r': 203,
      'g': 166,
      'b': 247,
    },
    'synString': {
      'r': 166,
      'g': 227,
      'b': 161,
    },
    'synNumber': {
      'r': 250,
      'g': 179,
      'b': 135,
    },
    'synComment': {
      'r': 69,
      'g': 71,
      'b': 90,
    },
    'synFunction': {
      'r': 137,
      'g': 180,
      'b': 250,
    },
    'synType': {
      'r': 249,
      'g': 226,
      'b': 175,
    },
    'synOperator': {
      'r': 137,
      'g': 220,
      'b': 235,
    },
    'synText': {
      'r': 205,
      'g': 214,
      'b': 244,
    },
    'synPunctuation': {
      'r': 88,
      'g': 91,
      'b': 112,
    },
    'synMeta': {
      'r': 69,
      'g': 71,
      'b': 90,
    },
    'synAtom': {
      'r': 250,
      'g': 179,
      'b': 135,
    },
    'synProperty': {
      'r': 137,
      'g': 180,
      'b': 250,
    },
    'synVariable': {
      'r': 205,
      'g': 214,
      'b': 244,
    },
    'scrollbarTrack': {
      'r': 24,
      'g': 24,
      'b': 37,
    },
    'scrollbarThumb': {
      'r': 52,
      'g': 52,
      'b': 66,
    },
    'scrollbarThumbHover': {
      'r': 68,
      'g': 68,
      'b': 81,
    },
    'ansiBlack': {
      'r': 43,
      'g': 43,
      'b': 58,
    },
    'ansiRed': {
      'r': 243,
      'g': 139,
      'b': 168,
    },
    'ansiGreen': {
      'r': 166,
      'g': 227,
      'b': 161,
    },
    'ansiYellow': {
      'r': 249,
      'g': 226,
      'b': 175,
    },
    'ansiBlue': {
      'r': 249,
      'g': 229,
      'b': 184,
    },
    'ansiMagenta': {
      'r': 137,
      'g': 180,
      'b': 250,
    },
    'ansiCyan': {
      'r': 193,
      'g': 203,
      'b': 212,
    },
    'ansiWhite': {
      'r': 143,
      'g': 149,
      'b': 174,
    },
    'ansiBlackBright': {
      'r': 91,
      'g': 94,
      'b': 113,
    },
    'ansiRedBright': {
      'r': 231,
      'g': 161,
      'b': 190,
    },
    'ansiGreenBright': {
      'r': 177,
      'g': 223,
      'b': 185,
    },
    'ansiYellowBright': {
      'r': 235,
      'g': 222,
      'b': 195,
    },
    'ansiBlueBright': {
      'r': 235,
      'g': 224,
      'b': 202,
    },
    'ansiMagentaBright': {
      'r': 157,
      'g': 190,
      'b': 248,
    },
    'ansiCyanBright': {
      'r': 196,
      'g': 206,
      'b': 221,
    },
    'ansiWhiteBright': {
      'r': 161,
      'g': 168,
      'b': 195,
    },
  }


export const cobalt2Palette: ColorPalette =
  {
    'bg': {
      'r': 25,
      'g': 53,
      'b': 73,
    },
    'bgSecondary': {
      'r': 18,
      'g': 39,
      'b': 56,
    },
    'bgTertiary': {
      'r': 38,
      'g': 65,
      'b': 83,
    },
    'bgInput': {
      'r': 34,
      'g': 61,
      'b': 80,
    },
    'bgHover': {
      'r': 153,
      'g': 238,
      'b': 255,
    },
    'bgActive': {
      'r': 48,
      'g': 73,
      'b': 91,
    },
    'border': {
      'r': 48,
      'g': 73,
      'b': 91,
    },
    'borderStrong': {
      'r': 64,
      'g': 87,
      'b': 104,
    },
    'borderSubtle': {
      'r': 46,
      'g': 70,
      'b': 87,
    },
    'text': {
      'r': 255,
      'g': 255,
      'b': 255,
    },
    'textSecondary': {
      'r': 174,
      'g': 184,
      'b': 191,
    },
    'textTertiary': {
      'r': 170,
      'g': 170,
      'b': 170,
    },
    'textInverse': {
      'r': 0,
      'g': 0,
      'b': 0,
    },
    'accent': {
      'r': 255,
      'g': 198,
      'b': 0,
    },
    'accentDim': {
      'r': 204,
      'g': 158,
      'b': 0,
    },
    'accentSecondary': {
      'r': 255,
      'g': 198,
      'b': 0,
    },
    'danger': {
      'r': 162,
      'g': 41,
      'b': 41,
    },
    'warning': {
      'r': 255,
      'g': 198,
      'b': 0,
    },
    'info': {
      'r': 255,
      'g': 104,
      'b': 184,
    },
    'success': {
      'r': 165,
      'g': 255,
      'b': 144,
    },
    'muted': {
      'r': 0,
      'g': 80,
      'b': 164,
    },
    'synKeyword': {
      'r': 255,
      'g': 157,
      'b': 0,
    },
    'synString': {
      'r': 165,
      'g': 255,
      'b': 144,
    },
    'synNumber': {
      'r': 255,
      'g': 98,
      'b': 140,
    },
    'synComment': {
      'r': 0,
      'g': 136,
      'b': 255,
    },
    'synFunction': {
      'r': 255,
      'g': 198,
      'b': 0,
    },
    'synType': {
      'r': 255,
      'g': 104,
      'b': 184,
    },
    'synOperator': {
      'r': 225,
      'g': 239,
      'b': 255,
    },
    'synText': {
      'r': 255,
      'g': 255,
      'b': 255,
    },
    'synPunctuation': {
      'r': 225,
      'g': 239,
      'b': 255,
    },
    'synMeta': {
      'r': 158,
      'g': 255,
      'b': 255,
    },
    'synAtom': {
      'r': 255,
      'g': 98,
      'b': 140,
    },
    'synProperty': {
      'r': 158,
      'g': 255,
      'b': 255,
    },
    'synVariable': {
      'r': 255,
      'g': 255,
      'b': 255,
    },
    'scrollbarTrack': {
      'r': 18,
      'g': 39,
      'b': 56,
    },
    'scrollbarThumb': {
      'r': 48,
      'g': 73,
      'b': 91,
    },
    'scrollbarThumbHover': {
      'r': 64,
      'g': 87,
      'b': 104,
    },
    'ansiBlack': {
      'r': 38,
      'g': 65,
      'b': 83,
    },
    'ansiRed': {
      'r': 162,
      'g': 41,
      'b': 41,
    },
    'ansiGreen': {
      'r': 165,
      'g': 255,
      'b': 144,
    },
    'ansiYellow': {
      'r': 255,
      'g': 198,
      'b': 0,
    },
    'ansiBlue': {
      'r': 255,
      'g': 104,
      'b': 184,
    },
    'ansiMagenta': {
      'r': 255,
      'g': 204,
      'b': 30,
    },
    'ansiCyan': {
      'r': 255,
      'g': 151,
      'b': 92,
    },
    'ansiWhite': {
      'r': 174,
      'g': 184,
      'b': 191,
    },
    'ansiBlackBright': {
      'r': 103,
      'g': 122,
      'b': 134,
    },
    'ansiRedBright': {
      'r': 189,
      'g': 105,
      'b': 105,
    },
    'ansiGreenBright': {
      'r': 192,
      'g': 255,
      'b': 177,
    },
    'ansiYellowBright': {
      'r': 255,
      'g': 215,
      'b': 76,
    },
    'ansiBlueBright': {
      'r': 255,
      'g': 149,
      'b': 205,
    },
    'ansiMagentaBright': {
      'r': 255,
      'g': 219,
      'b': 97,
    },
    'ansiCyanBright': {
      'r': 255,
      'g': 182,
      'b': 140,
    },
    'ansiWhiteBright': {
      'r': 198,
      'g': 205,
      'b': 210,
    },
  }


export const forestPalette: ColorPalette =
  {
    'bg': {
      'r': 26,
      'g': 42,
      'b': 51,
    },
    'bgSecondary': {
      'r': 35,
      'g': 48,
      'b': 57,
    },
    'bgTertiary': {
      'r': 39,
      'g': 54,
      'b': 63,
    },
    'bgInput': {
      'r': 35,
      'g': 50,
      'b': 59,
    },
    'bgHover': {
      'r': 49,
      'g': 68,
      'b': 67,
    },
    'bgActive': {
      'r': 48,
      'g': 63,
      'b': 71,
    },
    'border': {
      'r': 48,
      'g': 63,
      'b': 71,
    },
    'borderStrong': {
      'r': 64,
      'g': 78,
      'b': 85,
    },
    'borderSubtle': {
      'r': 46,
      'g': 60,
      'b': 68,
    },
    'text': {
      'r': 208,
      'g': 216,
      'b': 224,
    },
    'textSecondary': {
      'r': 144,
      'g': 155,
      'b': 163,
    },
    'textTertiary': {
      'r': 96,
      'g': 125,
      'b': 139,
    },
    'textInverse': {
      'r': 0,
      'g': 0,
      'b': 0,
    },
    'accent': {
      'r': 120,
      'g': 170,
      'b': 220,
    },
    'accentDim': {
      'r': 96,
      'g': 136,
      'b': 176,
    },
    'accentSecondary': {
      'r': 120,
      'g': 170,
      'b': 220,
    },
    'danger': {
      'r': 255,
      'g': 82,
      'b': 82,
    },
    'warning': {
      'r': 255,
      'g': 183,
      'b': 77,
    },
    'info': {
      'r': 255,
      'g': 183,
      'b': 77,
    },
    'success': {
      'r': 239,
      'g': 83,
      'b': 80,
    },
    'muted': {
      'r': 44,
      'g': 90,
      'b': 58,
    },
    'synKeyword': {
      'r': 169,
      'g': 211,
      'b': 171,
    },
    'synString': {
      'r': 239,
      'g': 83,
      'b': 80,
    },
    'synNumber': {
      'r': 188,
      'g': 143,
      'b': 106,
    },
    'synComment': {
      'r': 96,
      'g': 125,
      'b': 139,
    },
    'synFunction': {
      'r': 120,
      'g': 170,
      'b': 220,
    },
    'synType': {
      'r': 255,
      'g': 183,
      'b': 77,
    },
    'synOperator': {
      'r': 186,
      'g': 104,
      'b': 200,
    },
    'synText': {
      'r': 208,
      'g': 216,
      'b': 224,
    },
    'synPunctuation': {
      'r': 186,
      'g': 104,
      'b': 200,
    },
    'synMeta': {
      'r': 96,
      'g': 125,
      'b': 139,
    },
    'synAtom': {
      'r': 188,
      'g': 143,
      'b': 106,
    },
    'synProperty': {
      'r': 156,
      'g': 204,
      'b': 101,
    },
    'synVariable': {
      'r': 77,
      'g': 182,
      'b': 172,
    },
    'scrollbarTrack': {
      'r': 35,
      'g': 48,
      'b': 57,
    },
    'scrollbarThumb': {
      'r': 48,
      'g': 63,
      'b': 71,
    },
    'scrollbarThumbHover': {
      'r': 64,
      'g': 78,
      'b': 85,
    },
    'ansiBlack': {
      'r': 39,
      'g': 54,
      'b': 63,
    },
    'ansiRed': {
      'r': 255,
      'g': 82,
      'b': 82,
    },
    'ansiGreen': {
      'r': 239,
      'g': 83,
      'b': 80,
    },
    'ansiYellow': {
      'r': 255,
      'g': 183,
      'b': 77,
    },
    'ansiBlue': {
      'r': 255,
      'g': 191,
      'b': 98,
    },
    'ansiMagenta': {
      'r': 120,
      'g': 170,
      'b': 220,
    },
    'ansiCyan': {
      'r': 187,
      'g': 176,
      'b': 148,
    },
    'ansiWhite': {
      'r': 144,
      'g': 155,
      'b': 163,
    },
    'ansiBlackBright': {
      'r': 89,
      'g': 102,
      'b': 111,
    },
    'ansiRedBright': {
      'r': 240,
      'g': 122,
      'b': 124,
    },
    'ansiGreenBright': {
      'r': 229,
      'g': 122,
      'b': 123,
    },
    'ansiYellowBright': {
      'r': 240,
      'g': 192,
      'b': 121,
    },
    'ansiBlueBright': {
      'r': 240,
      'g': 198,
      'b': 135,
    },
    'ansiMagentaBright': {
      'r': 146,
      'g': 183,
      'b': 221,
    },
    'ansiCyanBright': {
      'r': 193,
      'g': 188,
      'b': 170,
    },
    'ansiWhiteBright': {
      'r': 163,
      'g': 173,
      'b': 181,
    },
  }


export const githubDarkPalette: ColorPalette =
  {
    'bg': {
      'r': 13,
      'g': 17,
      'b': 23,
    },
    'bgSecondary': {
      'r': 22,
      'g': 27,
      'b': 34,
    },
    'bgTertiary': {
      'r': 27,
      'g': 31,
      'b': 36,
    },
    'bgInput': {
      'r': 22,
      'g': 26,
      'b': 32,
    },
    'bgHover': {
      'r': 45,
      'g': 51,
      'b': 59,
    },
    'bgActive': {
      'r': 37,
      'g': 40,
      'b': 46,
    },
    'border': {
      'r': 37,
      'g': 40,
      'b': 46,
    },
    'borderStrong': {
      'r': 54,
      'g': 57,
      'b': 62,
    },
    'borderSubtle': {
      'r': 35,
      'g': 38,
      'b': 44,
    },
    'text': {
      'r': 201,
      'g': 209,
      'b': 217,
    },
    'textSecondary': {
      'r': 135,
      'g': 141,
      'b': 149,
    },
    'textTertiary': {
      'r': 139,
      'g': 148,
      'b': 158,
    },
    'textInverse': {
      'r': 0,
      'g': 0,
      'b': 0,
    },
    'accent': {
      'r': 255,
      'g': 123,
      'b': 114,
    },
    'accentDim': {
      'r': 204,
      'g': 98,
      'b': 91,
    },
    'accentSecondary': {
      'r': 126,
      'g': 231,
      'b': 135,
    },
    'danger': {
      'r': 249,
      'g': 117,
      'b': 131,
    },
    'warning': {
      'r': 210,
      'g': 153,
      'b': 34,
    },
    'info': {
      'r': 255,
      'g': 123,
      'b': 114,
    },
    'success': {
      'r': 165,
      'g': 214,
      'b': 255,
    },
    'muted': {
      'r': 38,
      'g': 79,
      'b': 120,
    },
    'synKeyword': {
      'r': 255,
      'g': 123,
      'b': 114,
    },
    'synString': {
      'r': 165,
      'g': 214,
      'b': 255,
    },
    'synNumber': {
      'r': 255,
      'g': 171,
      'b': 112,
    },
    'synComment': {
      'r': 139,
      'g': 148,
      'b': 158,
    },
    'synFunction': {
      'r': 126,
      'g': 231,
      'b': 135,
    },
    'synType': {
      'r': 255,
      'g': 123,
      'b': 114,
    },
    'synOperator': {
      'r': 201,
      'g': 209,
      'b': 217,
    },
    'synText': {
      'r': 201,
      'g': 209,
      'b': 217,
    },
    'synPunctuation': {
      'r': 139,
      'g': 148,
      'b': 158,
    },
    'synMeta': {
      'r': 139,
      'g': 148,
      'b': 158,
    },
    'synAtom': {
      'r': 255,
      'g': 171,
      'b': 112,
    },
    'synProperty': {
      'r': 210,
      'g': 168,
      'b': 255,
    },
    'synVariable': {
      'r': 121,
      'g': 192,
      'b': 255,
    },
    'scrollbarTrack': {
      'r': 22,
      'g': 27,
      'b': 34,
    },
    'scrollbarThumb': {
      'r': 37,
      'g': 40,
      'b': 46,
    },
    'scrollbarThumbHover': {
      'r': 54,
      'g': 57,
      'b': 62,
    },
    'ansiBlack': {
      'r': 27,
      'g': 31,
      'b': 36,
    },
    'ansiRed': {
      'r': 249,
      'g': 117,
      'b': 131,
    },
    'ansiGreen': {
      'r': 165,
      'g': 214,
      'b': 255,
    },
    'ansiYellow': {
      'r': 210,
      'g': 153,
      'b': 34,
    },
    'ansiBlue': {
      'r': 255,
      'g': 123,
      'b': 114,
    },
    'ansiMagenta': {
      'r': 126,
      'g': 231,
      'b': 135,
    },
    'ansiCyan': {
      'r': 255,
      'g': 138,
      'b': 130,
    },
    'ansiWhite': {
      'r': 135,
      'g': 141,
      'b': 149,
    },
    'ansiBlackBright': {
      'r': 79,
      'g': 84,
      'b': 90,
    },
    'ansiRedBright': {
      'r': 234,
      'g': 144,
      'b': 156,
    },
    'ansiGreenBright': {
      'r': 175,
      'g': 212,
      'b': 243,
    },
    'ansiYellowBright': {
      'r': 207,
      'g': 169,
      'b': 88,
    },
    'ansiBlueBright': {
      'r': 238,
      'g': 148,
      'b': 144,
    },
    'ansiMagentaBright': {
      'r': 148,
      'g': 224,
      'b': 159,
    },
    'ansiCyanBright': {
      'r': 238,
      'g': 159,
      'b': 156,
    },
    'ansiWhiteBright': {
      'r': 154,
      'g': 161,
      'b': 169,
    },
  }


export const githubLightPalette: ColorPalette =
  {
    'bg': {
      'r': 255,
      'g': 255,
      'b': 255,
    },
    'bgSecondary': {
      'r': 246,
      'g': 248,
      'b': 250,
    },
    'bgTertiary': {
      'r': 244,
      'g': 244,
      'b': 244,
    },
    'bgInput': {
      'r': 249,
      'g': 249,
      'b': 249,
    },
    'bgHover': {
      'r': 187,
      'g': 223,
      'b': 255,
    },
    'bgActive': {
      'r': 239,
      'g': 239,
      'b': 239,
    },
    'border': {
      'r': 239,
      'g': 239,
      'b': 239,
    },
    'borderStrong': {
      'r': 227,
      'g': 227,
      'b': 227,
    },
    'borderSubtle': {
      'r': 239,
      'g': 239,
      'b': 239,
    },
    'text': {
      'r': 36,
      'g': 41,
      'b': 46,
    },
    'textSecondary': {
      'r': 112,
      'g': 115,
      'b': 119,
    },
    'textTertiary': {
      'r': 110,
      'g': 119,
      'b': 129,
    },
    'textInverse': {
      'r': 255,
      'g': 255,
      'b': 255,
    },
    'accent': {
      'r': 215,
      'g': 58,
      'b': 73,
    },
    'accentDim': {
      'r': 172,
      'g': 46,
      'b': 58,
    },
    'accentSecondary': {
      'r': 34,
      'g': 134,
      'b': 58,
    },
    'danger': {
      'r': 203,
      'g': 36,
      'b': 49,
    },
    'warning': {
      'r': 176,
      'g': 136,
      'b': 0,
    },
    'info': {
      'r': 215,
      'g': 58,
      'b': 73,
    },
    'success': {
      'r': 3,
      'g': 47,
      'b': 98,
    },
    'muted': {
      'r': 187,
      'g': 223,
      'b': 255,
    },
    'synKeyword': {
      'r': 215,
      'g': 58,
      'b': 73,
    },
    'synString': {
      'r': 3,
      'g': 47,
      'b': 98,
    },
    'synNumber': {
      'r': 227,
      'g': 98,
      'b': 9,
    },
    'synComment': {
      'r': 106,
      'g': 115,
      'b': 125,
    },
    'synFunction': {
      'r': 34,
      'g': 134,
      'b': 58,
    },
    'synType': {
      'r': 215,
      'g': 58,
      'b': 73,
    },
    'synOperator': {
      'r': 36,
      'g': 41,
      'b': 46,
    },
    'synText': {
      'r': 36,
      'g': 41,
      'b': 46,
    },
    'synPunctuation': {
      'r': 106,
      'g': 115,
      'b': 125,
    },
    'synMeta': {
      'r': 106,
      'g': 115,
      'b': 125,
    },
    'synAtom': {
      'r': 227,
      'g': 98,
      'b': 9,
    },
    'synProperty': {
      'r': 111,
      'g': 66,
      'b': 193,
    },
    'synVariable': {
      'r': 0,
      'g': 92,
      'b': 197,
    },
    'scrollbarTrack': {
      'r': 246,
      'g': 248,
      'b': 250,
    },
    'scrollbarThumb': {
      'r': 239,
      'g': 239,
      'b': 239,
    },
    'scrollbarThumbHover': {
      'r': 227,
      'g': 227,
      'b': 227,
    },
    'ansiBlack': {
      'r': 244,
      'g': 244,
      'b': 244,
    },
    'ansiRed': {
      'r': 203,
      'g': 36,
      'b': 49,
    },
    'ansiGreen': {
      'r': 3,
      'g': 47,
      'b': 98,
    },
    'ansiYellow': {
      'r': 176,
      'g': 136,
      'b': 0,
    },
    'ansiBlue': {
      'r': 215,
      'g': 58,
      'b': 73,
    },
    'ansiMagenta': {
      'r': 34,
      'g': 134,
      'b': 58,
    },
    'ansiCyan': {
      'r': 189,
      'g': 51,
      'b': 64,
    },
    'ansiWhite': {
      'r': 112,
      'g': 115,
      'b': 119,
    },
    'ansiBlackBright': {
      'r': 181,
      'g': 183,
      'b': 184,
    },
    'ansiRedBright': {
      'r': 152,
      'g': 37,
      'b': 48,
    },
    'ansiGreenBright': {
      'r': 12,
      'g': 45,
      'b': 82,
    },
    'ansiYellowBright': {
      'r': 134,
      'g': 107,
      'b': 13,
    },
    'ansiBlueBright': {
      'r': 161,
      'g': 52,
      'b': 64,
    },
    'ansiMagentaBright': {
      'r': 34,
      'g': 106,
      'b': 54,
    },
    'ansiCyanBright': {
      'r': 143,
      'g': 47,
      'b': 58,
    },
    'ansiWhiteBright': {
      'r': 89,
      'g': 92,
      'b': 97,
    },
  }


export const gruvboxDarkPalette: ColorPalette =
  {
    'bg': {
      'r': 40,
      'g': 40,
      'b': 40,
    },
    'bgSecondary': {
      'r': 60,
      'g': 56,
      'b': 54,
    },
    'bgTertiary': {
      'r': 52,
      'g': 52,
      'b': 52,
    },
    'bgInput': {
      'r': 48,
      'g': 48,
      'b': 48,
    },
    'bgHover': {
      'r': 60,
      'g': 56,
      'b': 54,
    },
    'bgActive': {
      'r': 61,
      'g': 61,
      'b': 61,
    },
    'border': {
      'r': 61,
      'g': 61,
      'b': 61,
    },
    'borderStrong': {
      'r': 76,
      'g': 76,
      'b': 76,
    },
    'borderSubtle': {
      'r': 58,
      'g': 58,
      'b': 58,
    },
    'text': {
      'r': 235,
      'g': 219,
      'b': 178,
    },
    'textSecondary': {
      'r': 166,
      'g': 156,
      'b': 129,
    },
    'textTertiary': {
      'r': 146,
      'g': 131,
      'b': 116,
    },
    'textInverse': {
      'r': 0,
      'g': 0,
      'b': 0,
    },
    'accent': {
      'r': 254,
      'g': 128,
      'b': 25,
    },
    'accentDim': {
      'r': 203,
      'g': 102,
      'b': 20,
    },
    'accentSecondary': {
      'r': 250,
      'g': 189,
      'b': 47,
    },
    'danger': {
      'r': 251,
      'g': 73,
      'b': 52,
    },
    'warning': {
      'r': 250,
      'g': 189,
      'b': 47,
    },
    'info': {
      'r': 142,
      'g': 192,
      'b': 124,
    },
    'success': {
      'r': 184,
      'g': 187,
      'b': 38,
    },
    'muted': {
      'r': 80,
      'g': 73,
      'b': 69,
    },
    'synKeyword': {
      'r': 251,
      'g': 73,
      'b': 52,
    },
    'synString': {
      'r': 184,
      'g': 187,
      'b': 38,
    },
    'synNumber': {
      'r': 211,
      'g': 134,
      'b': 155,
    },
    'synComment': {
      'r': 146,
      'g': 131,
      'b': 116,
    },
    'synFunction': {
      'r': 250,
      'g': 189,
      'b': 47,
    },
    'synType': {
      'r': 142,
      'g': 192,
      'b': 124,
    },
    'synOperator': {
      'r': 235,
      'g': 219,
      'b': 178,
    },
    'synText': {
      'r': 235,
      'g': 219,
      'b': 178,
    },
    'synPunctuation': {
      'r': 146,
      'g': 131,
      'b': 116,
    },
    'synMeta': {
      'r': 146,
      'g': 131,
      'b': 116,
    },
    'synAtom': {
      'r': 254,
      'g': 128,
      'b': 25,
    },
    'synProperty': {
      'r': 142,
      'g': 192,
      'b': 124,
    },
    'synVariable': {
      'r': 131,
      'g': 165,
      'b': 152,
    },
    'scrollbarTrack': {
      'r': 60,
      'g': 56,
      'b': 54,
    },
    'scrollbarThumb': {
      'r': 61,
      'g': 61,
      'b': 61,
    },
    'scrollbarThumbHover': {
      'r': 76,
      'g': 76,
      'b': 76,
    },
    'ansiBlack': {
      'r': 52,
      'g': 52,
      'b': 52,
    },
    'ansiRed': {
      'r': 251,
      'g': 73,
      'b': 52,
    },
    'ansiGreen': {
      'r': 184,
      'g': 187,
      'b': 38,
    },
    'ansiYellow': {
      'r': 250,
      'g': 189,
      'b': 47,
    },
    'ansiBlue': {
      'r': 142,
      'g': 192,
      'b': 124,
    },
    'ansiMagenta': {
      'r': 250,
      'g': 196,
      'b': 71,
    },
    'ansiCyan': {
      'r': 198,
      'g': 160,
      'b': 74,
    },
    'ansiWhite': {
      'r': 166,
      'g': 156,
      'b': 129,
    },
    'ansiBlackBright': {
      'r': 106,
      'g': 102,
      'b': 89,
    },
    'ansiRedBright': {
      'r': 246,
      'g': 116,
      'b': 89,
    },
    'ansiGreenBright': {
      'r': 199,
      'g': 196,
      'b': 80,
    },
    'ansiYellowBright': {
      'r': 245,
      'g': 198,
      'b': 86,
    },
    'ansiBlueBright': {
      'r': 169,
      'g': 200,
      'b': 140,
    },
    'ansiMagentaBright': {
      'r': 245,
      'g': 202,
      'b': 103,
    },
    'ansiCyanBright': {
      'r': 209,
      'g': 177,
      'b': 105,
    },
    'ansiWhiteBright': {
      'r': 186,
      'g': 174,
      'b': 143,
    },
  }


export const gruvboxLightPalette: ColorPalette =
  {
    'bg': {
      'r': 251,
      'g': 241,
      'b': 199,
    },
    'bgSecondary': {
      'r': 235,
      'g': 219,
      'b': 178,
    },
    'bgTertiary': {
      'r': 240,
      'g': 231,
      'b': 191,
    },
    'bgInput': {
      'r': 245,
      'g': 236,
      'b': 195,
    },
    'bgHover': {
      'r': 255,
      'g': 196,
      'b': 46,
    },
    'bgActive': {
      'r': 235,
      'g': 226,
      'b': 187,
    },
    'border': {
      'r': 235,
      'g': 226,
      'b': 187,
    },
    'borderStrong': {
      'r': 223,
      'g': 214,
      'b': 177,
    },
    'borderSubtle': {
      'r': 235,
      'g': 226,
      'b': 188,
    },
    'text': {
      'r': 60,
      'g': 56,
      'b': 54,
    },
    'textSecondary': {
      'r': 126,
      'g': 120,
      'b': 104,
    },
    'textTertiary': {
      'r': 124,
      'g': 111,
      'b': 100,
    },
    'textInverse': {
      'r': 255,
      'g': 255,
      'b': 255,
    },
    'accent': {
      'r': 175,
      'g': 58,
      'b': 3,
    },
    'accentDim': {
      'r': 140,
      'g': 46,
      'b': 2,
    },
    'accentSecondary': {
      'r': 181,
      'g': 118,
      'b': 20,
    },
    'danger': {
      'r': 157,
      'g': 0,
      'b': 6,
    },
    'warning': {
      'r': 181,
      'g': 118,
      'b': 20,
    },
    'info': {
      'r': 66,
      'g': 123,
      'b': 88,
    },
    'success': {
      'r': 121,
      'g': 116,
      'b': 14,
    },
    'muted': {
      'r': 235,
      'g': 219,
      'b': 178,
    },
    'synKeyword': {
      'r': 157,
      'g': 0,
      'b': 6,
    },
    'synString': {
      'r': 121,
      'g': 116,
      'b': 14,
    },
    'synNumber': {
      'r': 143,
      'g': 63,
      'b': 113,
    },
    'synComment': {
      'r': 146,
      'g': 131,
      'b': 116,
    },
    'synFunction': {
      'r': 181,
      'g': 118,
      'b': 20,
    },
    'synType': {
      'r': 66,
      'g': 123,
      'b': 88,
    },
    'synOperator': {
      'r': 60,
      'g': 56,
      'b': 54,
    },
    'synText': {
      'r': 60,
      'g': 56,
      'b': 54,
    },
    'synPunctuation': {
      'r': 146,
      'g': 131,
      'b': 116,
    },
    'synMeta': {
      'r': 146,
      'g': 131,
      'b': 116,
    },
    'synAtom': {
      'r': 175,
      'g': 58,
      'b': 3,
    },
    'synProperty': {
      'r': 66,
      'g': 123,
      'b': 88,
    },
    'synVariable': {
      'r': 7,
      'g': 102,
      'b': 120,
    },
    'scrollbarTrack': {
      'r': 235,
      'g': 219,
      'b': 178,
    },
    'scrollbarThumb': {
      'r': 235,
      'g': 226,
      'b': 187,
    },
    'scrollbarThumbHover': {
      'r': 223,
      'g': 214,
      'b': 177,
    },
    'ansiBlack': {
      'r': 240,
      'g': 231,
      'b': 191,
    },
    'ansiRed': {
      'r': 157,
      'g': 0,
      'b': 6,
    },
    'ansiGreen': {
      'r': 121,
      'g': 116,
      'b': 14,
    },
    'ansiYellow': {
      'r': 181,
      'g': 118,
      'b': 20,
    },
    'ansiBlue': {
      'r': 66,
      'g': 123,
      'b': 88,
    },
    'ansiMagenta': {
      'r': 159,
      'g': 103,
      'b': 17,
    },
    'ansiCyan': {
      'r': 120,
      'g': 90,
      'b': 45,
    },
    'ansiWhite': {
      'r': 126,
      'g': 120,
      'b': 104,
    },
    'ansiBlackBright': {
      'r': 186,
      'g': 178,
      'b': 149,
    },
    'ansiRedBright': {
      'r': 127,
      'g': 16,
      'b': 20,
    },
    'ansiGreenBright': {
      'r': 102,
      'g': 97,
      'b': 26,
    },
    'ansiYellowBright': {
      'r': 144,
      'g': 99,
      'b': 30,
    },
    'ansiBlueBright': {
      'r': 64,
      'g': 102,
      'b': 77,
    },
    'ansiMagentaBright': {
      'r': 129,
      'g': 88,
      'b': 28,
    },
    'ansiCyanBright': {
      'r': 102,
      'g': 79,
      'b': 47,
    },
    'ansiWhiteBright': {
      'r': 106,
      'g': 100,
      'b': 89,
    },
  }


export const highContrastDarkPalette: ColorPalette =
  {
    'bg': {
      'r': 0,
      'g': 0,
      'b': 0,
    },
    'bgSecondary': {
      'r': 0,
      'g': 0,
      'b': 0,
    },
    'bgTertiary': {
      'r': 15,
      'g': 15,
      'b': 15,
    },
    'bgInput': {
      'r': 10,
      'g': 10,
      'b': 10,
    },
    'bgHover': {
      'r': 42,
      'g': 42,
      'b': 42,
    },
    'bgActive': {
      'r': 25,
      'g': 25,
      'b': 25,
    },
    'border': {
      'r': 25,
      'g': 25,
      'b': 25,
    },
    'borderStrong': {
      'r': 43,
      'g': 43,
      'b': 43,
    },
    'borderSubtle': {
      'r': 24,
      'g': 24,
      'b': 24,
    },
    'text': {
      'r': 255,
      'g': 255,
      'b': 255,
    },
    'textSecondary': {
      'r': 165,
      'g': 165,
      'b': 165,
    },
    'textTertiary': {
      'r': 176,
      'g': 176,
      'b': 176,
    },
    'textInverse': {
      'r': 0,
      'g': 0,
      'b': 0,
    },
    'accent': {
      'r': 255,
      'g': 255,
      'b': 0,
    },
    'accentDim': {
      'r': 204,
      'g': 204,
      'b': 0,
    },
    'accentSecondary': {
      'r': 0,
      'g': 153,
      'b': 255,
    },
    'danger': {
      'r': 255,
      'g': 0,
      'b': 0,
    },
    'warning': {
      'r': 255,
      'g': 255,
      'b': 0,
    },
    'info': {
      'r': 255,
      'g': 255,
      'b': 0,
    },
    'success': {
      'r': 0,
      'g': 255,
      'b': 0,
    },
    'muted': {
      'r': 58,
      'g': 90,
      'b': 138,
    },
    'synKeyword': {
      'r': 255,
      'g': 0,
      'b': 255,
    },
    'synString': {
      'r': 0,
      'g': 255,
      'b': 0,
    },
    'synNumber': {
      'r': 255,
      'g': 153,
      'b': 0,
    },
    'synComment': {
      'r': 128,
      'g': 128,
      'b': 128,
    },
    'synFunction': {
      'r': 0,
      'g': 153,
      'b': 255,
    },
    'synType': {
      'r': 255,
      'g': 255,
      'b': 0,
    },
    'synOperator': {
      'r': 0,
      'g': 255,
      'b': 255,
    },
    'synText': {
      'r': 255,
      'g': 255,
      'b': 255,
    },
    'synPunctuation': {
      'r': 255,
      'g': 255,
      'b': 255,
    },
    'synMeta': {
      'r': 128,
      'g': 128,
      'b': 128,
    },
    'synAtom': {
      'r': 255,
      'g': 153,
      'b': 0,
    },
    'synProperty': {
      'r': 0,
      'g': 255,
      'b': 255,
    },
    'synVariable': {
      'r': 255,
      'g': 255,
      'b': 255,
    },
    'scrollbarTrack': {
      'r': 0,
      'g': 0,
      'b': 0,
    },
    'scrollbarThumb': {
      'r': 25,
      'g': 25,
      'b': 25,
    },
    'scrollbarThumbHover': {
      'r': 43,
      'g': 43,
      'b': 43,
    },
    'ansiBlack': {
      'r': 15,
      'g': 15,
      'b': 15,
    },
    'ansiRed': {
      'r': 255,
      'g': 0,
      'b': 0,
    },
    'ansiGreen': {
      'r': 0,
      'g': 255,
      'b': 0,
    },
    'ansiYellow': {
      'r': 255,
      'g': 255,
      'b': 0,
    },
    'ansiBlue': {
      'r': 255,
      'g': 255,
      'b': 30,
    },
    'ansiMagenta': {
      'r': 0,
      'g': 153,
      'b': 255,
    },
    'ansiCyan': {
      'r': 255,
      'g': 255,
      'b': 57,
    },
    'ansiWhite': {
      'r': 165,
      'g': 165,
      'b': 165,
    },
    'ansiBlackBright': {
      'r': 87,
      'g': 87,
      'b': 87,
    },
    'ansiRedBright': {
      'r': 255,
      'g': 76,
      'b': 76,
    },
    'ansiGreenBright': {
      'r': 76,
      'g': 255,
      'b': 76,
    },
    'ansiYellowBright': {
      'r': 255,
      'g': 255,
      'b': 76,
    },
    'ansiBlueBright': {
      'r': 255,
      'g': 255,
      'b': 97,
    },
    'ansiMagentaBright': {
      'r': 76,
      'g': 183,
      'b': 255,
    },
    'ansiCyanBright': {
      'r': 255,
      'g': 255,
      'b': 116,
    },
    'ansiWhiteBright': {
      'r': 192,
      'g': 192,
      'b': 192,
    },
  }


export const highContrastLightPalette: ColorPalette =
  {
    'bg': {
      'r': 255,
      'g': 255,
      'b': 255,
    },
    'bgSecondary': {
      'r': 255,
      'g': 255,
      'b': 255,
    },
    'bgTertiary': {
      'r': 244,
      'g': 244,
      'b': 244,
    },
    'bgInput': {
      'r': 249,
      'g': 249,
      'b': 249,
    },
    'bgHover': {
      'r': 255,
      'g': 255,
      'b': 204,
    },
    'bgActive': {
      'r': 239,
      'g': 239,
      'b': 239,
    },
    'border': {
      'r': 239,
      'g': 239,
      'b': 239,
    },
    'borderStrong': {
      'r': 227,
      'g': 227,
      'b': 227,
    },
    'borderSubtle': {
      'r': 239,
      'g': 239,
      'b': 239,
    },
    'text': {
      'r': 0,
      'g': 0,
      'b': 0,
    },
    'textSecondary': {
      'r': 89,
      'g': 89,
      'b': 89,
    },
    'textTertiary': {
      'r': 80,
      'g': 80,
      'b': 80,
    },
    'textInverse': {
      'r': 255,
      'g': 255,
      'b': 255,
    },
    'accent': {
      'r': 0,
      'g': 0,
      'b': 255,
    },
    'accentDim': {
      'r': 0,
      'g': 0,
      'b': 204,
    },
    'accentSecondary': {
      'r': 0,
      'g': 0,
      'b': 255,
    },
    'danger': {
      'r': 200,
      'g': 0,
      'b': 0,
    },
    'warning': {
      'r': 208,
      'g': 72,
      'b': 0,
    },
    'info': {
      'r': 0,
      'g': 128,
      'b': 128,
    },
    'success': {
      'r': 0,
      'g': 128,
      'b': 0,
    },
    'muted': {
      'r': 77,
      'g': 144,
      'b': 254,
    },
    'synKeyword': {
      'r': 128,
      'g': 0,
      'b': 128,
    },
    'synString': {
      'r': 0,
      'g': 128,
      'b': 0,
    },
    'synNumber': {
      'r': 208,
      'g': 72,
      'b': 0,
    },
    'synComment': {
      'r': 112,
      'g': 112,
      'b': 112,
    },
    'synFunction': {
      'r': 0,
      'g': 0,
      'b': 255,
    },
    'synType': {
      'r': 0,
      'g': 128,
      'b': 128,
    },
    'synOperator': {
      'r': 0,
      'g': 128,
      'b': 128,
    },
    'synText': {
      'r': 0,
      'g': 0,
      'b': 0,
    },
    'synPunctuation': {
      'r': 0,
      'g': 0,
      'b': 0,
    },
    'synMeta': {
      'r': 112,
      'g': 112,
      'b': 112,
    },
    'synAtom': {
      'r': 208,
      'g': 72,
      'b': 0,
    },
    'synProperty': {
      'r': 0,
      'g': 0,
      'b': 255,
    },
    'synVariable': {
      'r': 0,
      'g': 0,
      'b': 0,
    },
    'scrollbarTrack': {
      'r': 255,
      'g': 255,
      'b': 255,
    },
    'scrollbarThumb': {
      'r': 239,
      'g': 239,
      'b': 239,
    },
    'scrollbarThumbHover': {
      'r': 227,
      'g': 227,
      'b': 227,
    },
    'ansiBlack': {
      'r': 244,
      'g': 244,
      'b': 244,
    },
    'ansiRed': {
      'r': 200,
      'g': 0,
      'b': 0,
    },
    'ansiGreen': {
      'r': 0,
      'g': 128,
      'b': 0,
    },
    'ansiYellow': {
      'r': 208,
      'g': 72,
      'b': 0,
    },
    'ansiBlue': {
      'r': 0,
      'g': 128,
      'b': 128,
    },
    'ansiMagenta': {
      'r': 0,
      'g': 0,
      'b': 255,
    },
    'ansiCyan': {
      'r': 0,
      'g': 64,
      'b': 191,
    },
    'ansiWhite': {
      'r': 89,
      'g': 89,
      'b': 89,
    },
    'ansiBlackBright': {
      'r': 170,
      'g': 170,
      'b': 170,
    },
    'ansiRedBright': {
      'r': 140,
      'g': 0,
      'b': 0,
    },
    'ansiGreenBright': {
      'r': 0,
      'g': 89,
      'b': 0,
    },
    'ansiYellowBright': {
      'r': 145,
      'g': 50,
      'b': 0,
    },
    'ansiBlueBright': {
      'r': 0,
      'g': 89,
      'b': 89,
    },
    'ansiMagentaBright': {
      'r': 0,
      'g': 0,
      'b': 178,
    },
    'ansiCyanBright': {
      'r': 0,
      'g': 44,
      'b': 133,
    },
    'ansiWhiteBright': {
      'r': 62,
      'g': 62,
      'b': 62,
    },
  }


export const materialDarkPalette: ColorPalette =
  {
    'bg': {
      'r': 33,
      'g': 33,
      'b': 33,
    },
    'bgSecondary': {
      'r': 32,
      'g': 35,
      'b': 37,
    },
    'bgTertiary': {
      'r': 46,
      'g': 46,
      'b': 46,
    },
    'bgInput': {
      'r': 41,
      'g': 41,
      'b': 41,
    },
    'bgHover': {
      'r': 45,
      'g': 51,
      'b': 59,
    },
    'bgActive': {
      'r': 55,
      'g': 55,
      'b': 55,
    },
    'border': {
      'r': 55,
      'g': 55,
      'b': 55,
    },
    'borderStrong': {
      'r': 71,
      'g': 71,
      'b': 71,
    },
    'borderSubtle': {
      'r': 52,
      'g': 52,
      'b': 52,
    },
    'text': {
      'r': 189,
      'g': 189,
      'b': 189,
    },
    'textSecondary': {
      'r': 134,
      'g': 134,
      'b': 134,
    },
    'textTertiary': {
      'r': 112,
      'g': 125,
      'b': 139,
    },
    'textInverse': {
      'r': 0,
      'g': 0,
      'b': 0,
    },
    'accent': {
      'r': 255,
      'g': 95,
      'b': 82,
    },
    'accentDim': {
      'r': 204,
      'g': 76,
      'b': 65,
    },
    'accentSecondary': {
      'r': 86,
      'g': 200,
      'b': 216,
    },
    'danger': {
      'r': 255,
      'g': 95,
      'b': 82,
    },
    'warning': {
      'r': 255,
      'g': 173,
      'b': 66,
    },
    'info': {
      'r': 255,
      'g': 95,
      'b': 82,
    },
    'success': {
      'r': 255,
      'g': 173,
      'b': 66,
    },
    'muted': {
      'r': 255,
      'g': 255,
      'b': 255,
    },
    'synKeyword': {
      'r': 255,
      'g': 95,
      'b': 82,
    },
    'synString': {
      'r': 255,
      'g': 173,
      'b': 66,
    },
    'synNumber': {
      'r': 250,
      'g': 207,
      'b': 78,
    },
    'synComment': {
      'r': 112,
      'g': 125,
      'b': 139,
    },
    'synFunction': {
      'r': 86,
      'g': 200,
      'b': 216,
    },
    'synType': {
      'r': 255,
      'g': 95,
      'b': 82,
    },
    'synOperator': {
      'r': 189,
      'g': 189,
      'b': 189,
    },
    'synText': {
      'r': 189,
      'g': 189,
      'b': 189,
    },
    'synPunctuation': {
      'r': 112,
      'g': 125,
      'b': 139,
    },
    'synMeta': {
      'r': 112,
      'g': 125,
      'b': 139,
    },
    'synAtom': {
      'r': 255,
      'g': 110,
      'b': 64,
    },
    'synProperty': {
      'r': 207,
      'g': 110,
      'b': 223,
    },
    'synVariable': {
      'r': 153,
      'g': 208,
      'b': 102,
    },
    'scrollbarTrack': {
      'r': 32,
      'g': 35,
      'b': 37,
    },
    'scrollbarThumb': {
      'r': 55,
      'g': 55,
      'b': 55,
    },
    'scrollbarThumbHover': {
      'r': 71,
      'g': 71,
      'b': 71,
    },
    'ansiBlack': {
      'r': 46,
      'g': 46,
      'b': 46,
    },
    'ansiRed': {
      'r': 255,
      'g': 95,
      'b': 82,
    },
    'ansiGreen': {
      'r': 255,
      'g': 173,
      'b': 66,
    },
    'ansiYellow': {
      'r': 255,
      'g': 182,
      'b': 88,
    },
    'ansiBlue': {
      'r': 255,
      'g': 114,
      'b': 102,
    },
    'ansiMagenta': {
      'r': 86,
      'g': 200,
      'b': 216,
    },
    'ansiCyan': {
      'r': 255,
      'g': 130,
      'b': 120,
    },
    'ansiWhite': {
      'r': 134,
      'g': 134,
      'b': 134,
    },
    'ansiBlackBright': {
      'r': 88,
      'g': 88,
      'b': 88,
    },
    'ansiRedBright': {
      'r': 235,
      'g': 123,
      'b': 114,
    },
    'ansiGreenBright': {
      'r': 235,
      'g': 177,
      'b': 102,
    },
    'ansiYellowBright': {
      'r': 235,
      'g': 184,
      'b': 118,
    },
    'ansiBlueBright': {
      'r': 235,
      'g': 136,
      'b': 128,
    },
    'ansiMagentaBright': {
      'r': 116,
      'g': 196,
      'b': 207,
    },
    'ansiCyanBright': {
      'r': 235,
      'g': 147,
      'b': 140,
    },
    'ansiWhiteBright': {
      'r': 150,
      'g': 150,
      'b': 150,
    },
  }


export const materialLightPalette: ColorPalette =
  {
    'bg': {
      'r': 255,
      'g': 255,
      'b': 255,
    },
    'bgSecondary': {
      'r': 250,
      'g': 250,
      'b': 250,
    },
    'bgTertiary': {
      'r': 244,
      'g': 244,
      'b': 244,
    },
    'bgInput': {
      'r': 249,
      'g': 249,
      'b': 249,
    },
    'bgHover': {
      'r': 0,
      'g': 0,
      'b': 0,
    },
    'bgActive': {
      'r': 239,
      'g': 239,
      'b': 239,
    },
    'border': {
      'r': 239,
      'g': 239,
      'b': 239,
    },
    'borderStrong': {
      'r': 227,
      'g': 227,
      'b': 227,
    },
    'borderSubtle': {
      'r': 239,
      'g': 239,
      'b': 239,
    },
    'text': {
      'r': 33,
      'g': 33,
      'b': 33,
    },
    'textSecondary': {
      'r': 110,
      'g': 110,
      'b': 110,
    },
    'textTertiary': {
      'r': 117,
      'g': 117,
      'b': 117,
    },
    'textInverse': {
      'r': 255,
      'g': 255,
      'b': 255,
    },
    'accent': {
      'r': 255,
      'g': 62,
      'b': 0,
    },
    'accentDim': {
      'r': 204,
      'g': 49,
      'b': 0,
    },
    'accentSecondary': {
      'r': 255,
      'g': 62,
      'b': 0,
    },
    'danger': {
      'r': 244,
      'g': 67,
      'b': 54,
    },
    'warning': {
      'r': 255,
      'g': 152,
      'b': 0,
    },
    'info': {
      'r': 255,
      'g': 152,
      'b': 0,
    },
    'success': {
      'r': 67,
      'g': 160,
      'b': 71,
    },
    'muted': {
      'r': 221,
      'g': 238,
      'b': 255,
    },
    'synKeyword': {
      'r': 0,
      'g': 172,
      'b': 193,
    },
    'synString': {
      'r': 67,
      'g': 160,
      'b': 71,
    },
    'synNumber': {
      'r': 255,
      'g': 152,
      'b': 0,
    },
    'synComment': {
      'r': 117,
      'g': 117,
      'b': 117,
    },
    'synFunction': {
      'r': 255,
      'g': 62,
      'b': 0,
    },
    'synType': {
      'r': 255,
      'g': 152,
      'b': 0,
    },
    'synOperator': {
      'r': 57,
      'g': 73,
      'b': 171,
    },
    'synText': {
      'r': 33,
      'g': 33,
      'b': 33,
    },
    'synPunctuation': {
      'r': 117,
      'g': 117,
      'b': 117,
    },
    'synMeta': {
      'r': 117,
      'g': 117,
      'b': 117,
    },
    'synAtom': {
      'r': 142,
      'g': 36,
      'b': 170,
    },
    'synProperty': {
      'r': 0,
      'g': 137,
      'b': 123,
    },
    'synVariable': {
      'r': 66,
      'g': 66,
      'b': 66,
    },
    'scrollbarTrack': {
      'r': 250,
      'g': 250,
      'b': 250,
    },
    'scrollbarThumb': {
      'r': 239,
      'g': 239,
      'b': 239,
    },
    'scrollbarThumbHover': {
      'r': 227,
      'g': 227,
      'b': 227,
    },
    'ansiBlack': {
      'r': 244,
      'g': 244,
      'b': 244,
    },
    'ansiRed': {
      'r': 244,
      'g': 67,
      'b': 54,
    },
    'ansiGreen': {
      'r': 67,
      'g': 160,
      'b': 71,
    },
    'ansiYellow': {
      'r': 255,
      'g': 152,
      'b': 0,
    },
    'ansiBlue': {
      'r': 224,
      'g': 133,
      'b': 0,
    },
    'ansiMagenta': {
      'r': 255,
      'g': 62,
      'b': 0,
    },
    'ansiCyan': {
      'r': 255,
      'g': 107,
      'b': 0,
    },
    'ansiWhite': {
      'r': 110,
      'g': 110,
      'b': 110,
    },
    'ansiBlackBright': {
      'r': 180,
      'g': 180,
      'b': 180,
    },
    'ansiRedBright': {
      'r': 180,
      'g': 56,
      'b': 47,
    },
    'ansiGreenBright': {
      'r': 56,
      'g': 121,
      'b': 59,
    },
    'ansiYellowBright': {
      'r': 188,
      'g': 116,
      'b': 9,
    },
    'ansiBlueBright': {
      'r': 166,
      'g': 103,
      'b': 9,
    },
    'ansiMagentaBright': {
      'r': 188,
      'g': 53,
      'b': 9,
    },
    'ansiCyanBright': {
      'r': 188,
      'g': 84,
      'b': 9,
    },
    'ansiWhiteBright': {
      'r': 86,
      'g': 86,
      'b': 86,
    },
  }


export const materialOceanPalette: ColorPalette =
  {
    'bg': {
      'r': 15,
      'g': 17,
      'b': 26,
    },
    'bgSecondary': {
      'r': 15,
      'g': 17,
      'b': 26,
    },
    'bgTertiary': {
      'r': 29,
      'g': 31,
      'b': 39,
    },
    'bgInput': {
      'r': 24,
      'g': 26,
      'b': 35,
    },
    'bgHover': {
      'r': 0,
      'g': 0,
      'b': 0,
    },
    'bgActive': {
      'r': 39,
      'g': 40,
      'b': 48,
    },
    'border': {
      'r': 39,
      'g': 40,
      'b': 48,
    },
    'borderStrong': {
      'r': 56,
      'g': 57,
      'b': 64,
    },
    'borderSubtle': {
      'r': 37,
      'g': 38,
      'b': 46,
    },
    'text': {
      'r': 143,
      'g': 147,
      'b': 162,
    },
    'textSecondary': {
      'r': 98,
      'g': 101,
      'b': 114,
    },
    'textTertiary': {
      'r': 70,
      'g': 75,
      'b': 93,
    },
    'textInverse': {
      'r': 0,
      'g': 0,
      'b': 0,
    },
    'accent': {
      'r': 255,
      'g': 204,
      'b': 0,
    },
    'accentDim': {
      'r': 204,
      'g': 163,
      'b': 0,
    },
    'accentSecondary': {
      'r': 130,
      'g': 170,
      'b': 255,
    },
    'danger': {
      'r': 255,
      'g': 83,
      'b': 112,
    },
    'warning': {
      'r': 255,
      'g': 203,
      'b': 107,
    },
    'info': {
      'r': 222,
      'g': 203,
      'b': 107,
    },
    'success': {
      'r': 195,
      'g': 232,
      'b': 141,
    },
    'muted': {
      'r': 113,
      'g': 124,
      'b': 180,
    },
    'synKeyword': {
      'r': 199,
      'g': 146,
      'b': 234,
    },
    'synString': {
      'r': 195,
      'g': 232,
      'b': 141,
    },
    'synNumber': {
      'r': 255,
      'g': 83,
      'b': 112,
    },
    'synComment': {
      'r': 70,
      'g': 75,
      'b': 93,
    },
    'synFunction': {
      'r': 130,
      'g': 170,
      'b': 255,
    },
    'synType': {
      'r': 222,
      'g': 203,
      'b': 107,
    },
    'synOperator': {
      'r': 137,
      'g': 221,
      'b': 255,
    },
    'synText': {
      'r': 143,
      'g': 147,
      'b': 162,
    },
    'synPunctuation': {
      'r': 70,
      'g': 75,
      'b': 93,
    },
    'synMeta': {
      'r': 70,
      'g': 75,
      'b': 93,
    },
    'synAtom': {
      'r': 247,
      'g': 140,
      'b': 108,
    },
    'synProperty': {
      'r': 199,
      'g': 146,
      'b': 234,
    },
    'synVariable': {
      'r': 240,
      'g': 113,
      'b': 120,
    },
    'scrollbarTrack': {
      'r': 15,
      'g': 17,
      'b': 26,
    },
    'scrollbarThumb': {
      'r': 39,
      'g': 40,
      'b': 48,
    },
    'scrollbarThumbHover': {
      'r': 56,
      'g': 57,
      'b': 64,
    },
    'ansiBlack': {
      'r': 29,
      'g': 31,
      'b': 39,
    },
    'ansiRed': {
      'r': 255,
      'g': 83,
      'b': 112,
    },
    'ansiGreen': {
      'r': 195,
      'g': 232,
      'b': 141,
    },
    'ansiYellow': {
      'r': 255,
      'g': 203,
      'b': 107,
    },
    'ansiBlue': {
      'r': 222,
      'g': 203,
      'b': 107,
    },
    'ansiMagenta': {
      'r': 130,
      'g': 170,
      'b': 255,
    },
    'ansiCyan': {
      'r': 238,
      'g': 203,
      'b': 53,
    },
    'ansiWhite': {
      'r': 98,
      'g': 101,
      'b': 114,
    },
    'ansiBlackBright': {
      'r': 63,
      'g': 65,
      'b': 75,
    },
    'ansiRedBright': {
      'r': 221,
      'g': 102,
      'b': 127,
    },
    'ansiGreenBright': {
      'r': 179,
      'g': 206,
      'b': 147,
    },
    'ansiYellowBright': {
      'r': 221,
      'g': 186,
      'b': 123,
    },
    'ansiBlueBright': {
      'r': 198,
      'g': 186,
      'b': 123,
    },
    'ansiMagentaBright': {
      'r': 133,
      'g': 163,
      'b': 227,
    },
    'ansiCyanBright': {
      'r': 209,
      'g': 186,
      'b': 85,
    },
    'ansiWhiteBright': {
      'r': 111,
      'g': 114,
      'b': 128,
    },
  }


export const monokaiPalette: ColorPalette =
  {
    'bg': {
      'r': 39,
      'g': 40,
      'b': 34,
    },
    'bgSecondary': {
      'r': 65,
      'g': 67,
      'b': 57,
    },
    'bgTertiary': {
      'r': 51,
      'g': 52,
      'b': 47,
    },
    'bgInput': {
      'r': 47,
      'g': 48,
      'b': 42,
    },
    'bgHover': {
      'r': 62,
      'g': 61,
      'b': 50,
    },
    'bgActive': {
      'r': 60,
      'g': 61,
      'b': 56,
    },
    'border': {
      'r': 60,
      'g': 61,
      'b': 56,
    },
    'borderStrong': {
      'r': 75,
      'g': 76,
      'b': 71,
    },
    'borderSubtle': {
      'r': 57,
      'g': 58,
      'b': 53,
    },
    'text': {
      'r': 248,
      'g': 248,
      'b': 242,
    },
    'textSecondary': {
      'r': 174,
      'g': 175,
      'b': 169,
    },
    'textTertiary': {
      'r': 136,
      'g': 132,
      'b': 111,
    },
    'textInverse': {
      'r': 0,
      'g': 0,
      'b': 0,
    },
    'accent': {
      'r': 249,
      'g': 38,
      'b': 114,
    },
    'accentDim': {
      'r': 199,
      'g': 30,
      'b': 91,
    },
    'accentSecondary': {
      'r': 102,
      'g': 217,
      'b': 239,
    },
    'danger': {
      'r': 244,
      'g': 71,
      'b': 71,
    },
    'warning': {
      'r': 253,
      'g': 151,
      'b': 31,
    },
    'info': {
      'r': 102,
      'g': 217,
      'b': 239,
    },
    'success': {
      'r': 230,
      'g': 219,
      'b': 116,
    },
    'muted': {
      'r': 73,
      'g': 72,
      'b': 62,
    },
    'synKeyword': {
      'r': 249,
      'g': 38,
      'b': 114,
    },
    'synString': {
      'r': 230,
      'g': 219,
      'b': 116,
    },
    'synNumber': {
      'r': 174,
      'g': 129,
      'b': 255,
    },
    'synComment': {
      'r': 136,
      'g': 132,
      'b': 111,
    },
    'synFunction': {
      'r': 102,
      'g': 217,
      'b': 239,
    },
    'synType': {
      'r': 102,
      'g': 217,
      'b': 239,
    },
    'synOperator': {
      'r': 249,
      'g': 38,
      'b': 114,
    },
    'synText': {
      'r': 248,
      'g': 248,
      'b': 242,
    },
    'synPunctuation': {
      'r': 248,
      'g': 248,
      'b': 242,
    },
    'synMeta': {
      'r': 136,
      'g': 132,
      'b': 111,
    },
    'synAtom': {
      'r': 174,
      'g': 129,
      'b': 255,
    },
    'synProperty': {
      'r': 166,
      'g': 226,
      'b': 46,
    },
    'synVariable': {
      'r': 253,
      'g': 151,
      'b': 31,
    },
    'scrollbarTrack': {
      'r': 65,
      'g': 67,
      'b': 57,
    },
    'scrollbarThumb': {
      'r': 60,
      'g': 61,
      'b': 56,
    },
    'scrollbarThumbHover': {
      'r': 75,
      'g': 76,
      'b': 71,
    },
    'ansiBlack': {
      'r': 51,
      'g': 52,
      'b': 47,
    },
    'ansiRed': {
      'r': 244,
      'g': 71,
      'b': 71,
    },
    'ansiGreen': {
      'r': 230,
      'g': 219,
      'b': 116,
    },
    'ansiYellow': {
      'r': 253,
      'g': 151,
      'b': 31,
    },
    'ansiBlue': {
      'r': 102,
      'g': 217,
      'b': 239,
    },
    'ansiMagenta': {
      'r': 120,
      'g': 221,
      'b': 240,
    },
    'ansiCyan': {
      'r': 175,
      'g': 127,
      'b': 176,
    },
    'ansiWhite': {
      'r': 174,
      'g': 175,
      'b': 169,
    },
    'ansiBlackBright': {
      'r': 110,
      'g': 110,
      'b': 105,
    },
    'ansiRedBright': {
      'r': 245,
      'g': 124,
      'b': 122,
    },
    'ansiGreenBright': {
      'r': 235,
      'g': 227,
      'b': 153,
    },
    'ansiYellowBright': {
      'r': 251,
      'g': 180,
      'b': 94,
    },
    'ansiBlueBright': {
      'r': 145,
      'g': 226,
      'b': 239,
    },
    'ansiMagentaBright': {
      'r': 158,
      'g': 229,
      'b': 240,
    },
    'ansiCyanBright': {
      'r': 196,
      'g': 163,
      'b': 195,
    },
    'ansiWhiteBright': {
      'r': 196,
      'g': 196,
      'b': 190,
    },
  }


export const nordPalette: ColorPalette =
  {
    'bg': {
      'r': 46,
      'g': 52,
      'b': 64,
    },
    'bgSecondary': {
      'r': 37,
      'g': 42,
      'b': 51,
    },
    'bgTertiary': {
      'r': 58,
      'g': 64,
      'b': 75,
    },
    'bgInput': {
      'r': 54,
      'g': 60,
      'b': 71,
    },
    'bgHover': {
      'r': 59,
      'g': 66,
      'b': 82,
    },
    'bgActive': {
      'r': 66,
      'g': 72,
      'b': 83,
    },
    'border': {
      'r': 66,
      'g': 72,
      'b': 83,
    },
    'borderStrong': {
      'r': 81,
      'g': 86,
      'b': 96,
    },
    'borderSubtle': {
      'r': 63,
      'g': 69,
      'b': 79,
    },
    'text': {
      'r': 216,
      'g': 222,
      'b': 233,
    },
    'textSecondary': {
      'r': 156,
      'g': 162,
      'b': 173,
    },
    'textTertiary': {
      'r': 76,
      'g': 86,
      'b': 106,
    },
    'textInverse': {
      'r': 0,
      'g': 0,
      'b': 0,
    },
    'accent': {
      'r': 94,
      'g': 129,
      'b': 172,
    },
    'accentDim': {
      'r': 75,
      'g': 103,
      'b': 137,
    },
    'accentSecondary': {
      'r': 143,
      'g': 188,
      'b': 187,
    },
    'danger': {
      'r': 191,
      'g': 97,
      'b': 106,
    },
    'warning': {
      'r': 235,
      'g': 203,
      'b': 139,
    },
    'info': {
      'r': 235,
      'g': 203,
      'b': 139,
    },
    'success': {
      'r': 163,
      'g': 190,
      'b': 140,
    },
    'muted': {
      'r': 67,
      'g': 76,
      'b': 94,
    },
    'synKeyword': {
      'r': 94,
      'g': 129,
      'b': 172,
    },
    'synString': {
      'r': 163,
      'g': 190,
      'b': 140,
    },
    'synNumber': {
      'r': 208,
      'g': 135,
      'b': 112,
    },
    'synComment': {
      'r': 76,
      'g': 86,
      'b': 106,
    },
    'synFunction': {
      'r': 143,
      'g': 188,
      'b': 187,
    },
    'synType': {
      'r': 235,
      'g': 203,
      'b': 139,
    },
    'synOperator': {
      'r': 180,
      'g': 142,
      'b': 173,
    },
    'synText': {
      'r': 216,
      'g': 222,
      'b': 233,
    },
    'synPunctuation': {
      'r': 216,
      'g': 222,
      'b': 233,
    },
    'synMeta': {
      'r': 76,
      'g': 86,
      'b': 106,
    },
    'synAtom': {
      'r': 180,
      'g': 142,
      'b': 173,
    },
    'synProperty': {
      'r': 136,
      'g': 192,
      'b': 208,
    },
    'synVariable': {
      'r': 216,
      'g': 222,
      'b': 233,
    },
    'scrollbarTrack': {
      'r': 37,
      'g': 42,
      'b': 51,
    },
    'scrollbarThumb': {
      'r': 66,
      'g': 72,
      'b': 83,
    },
    'scrollbarThumbHover': {
      'r': 81,
      'g': 86,
      'b': 96,
    },
    'ansiBlack': {
      'r': 58,
      'g': 64,
      'b': 75,
    },
    'ansiRed': {
      'r': 191,
      'g': 97,
      'b': 106,
    },
    'ansiGreen': {
      'r': 163,
      'g': 190,
      'b': 140,
    },
    'ansiYellow': {
      'r': 235,
      'g': 203,
      'b': 139,
    },
    'ansiBlue': {
      'r': 237,
      'g': 209,
      'b': 152,
    },
    'ansiMagenta': {
      'r': 143,
      'g': 188,
      'b': 187,
    },
    'ansiCyan': {
      'r': 164,
      'g': 166,
      'b': 155,
    },
    'ansiWhite': {
      'r': 156,
      'g': 162,
      'b': 173,
    },
    'ansiBlackBright': {
      'r': 105,
      'g': 111,
      'b': 122,
    },
    'ansiRedBright': {
      'r': 198,
      'g': 134,
      'b': 144,
    },
    'ansiGreenBright': {
      'r': 178,
      'g': 199,
      'b': 167,
    },
    'ansiYellowBright': {
      'r': 229,
      'g': 208,
      'b': 167,
    },
    'ansiBlueBright': {
      'r': 230,
      'g': 212,
      'b': 176,
    },
    'ansiMagentaBright': {
      'r': 164,
      'g': 198,
      'b': 200,
    },
    'ansiCyanBright': {
      'r': 179,
      'g': 182,
      'b': 178,
    },
    'ansiWhiteBright': {
      'r': 174,
      'g': 180,
      'b': 191,
    },
  }


export const palenightPalette: ColorPalette =
  {
    'bg': {
      'r': 41,
      'g': 45,
      'b': 62,
    },
    'bgSecondary': {
      'r': 32,
      'g': 35,
      'b': 49,
    },
    'bgTertiary': {
      'r': 53,
      'g': 57,
      'b': 73,
    },
    'bgInput': {
      'r': 49,
      'g': 53,
      'b': 69,
    },
    'bgHover': {
      'r': 46,
      'g': 50,
      'b': 72,
    },
    'bgActive': {
      'r': 62,
      'g': 66,
      'b': 81,
    },
    'border': {
      'r': 62,
      'g': 66,
      'b': 81,
    },
    'borderStrong': {
      'r': 77,
      'g': 81,
      'b': 94,
    },
    'borderSubtle': {
      'r': 59,
      'g': 63,
      'b': 77,
    },
    'text': {
      'r': 166,
      'g': 172,
      'b': 205,
    },
    'textSecondary': {
      'r': 122,
      'g': 127,
      'b': 154,
    },
    'textTertiary': {
      'r': 103,
      'g': 110,
      'b': 149,
    },
    'textInverse': {
      'r': 0,
      'g': 0,
      'b': 0,
    },
    'accent': {
      'r': 130,
      'g': 170,
      'b': 255,
    },
    'accentDim': {
      'r': 104,
      'g': 136,
      'b': 204,
    },
    'accentSecondary': {
      'r': 130,
      'g': 170,
      'b': 255,
    },
    'danger': {
      'r': 255,
      'g': 83,
      'b': 112,
    },
    'warning': {
      'r': 255,
      'g': 203,
      'b': 107,
    },
    'info': {
      'r': 199,
      'g': 146,
      'b': 234,
    },
    'success': {
      'r': 195,
      'g': 232,
      'b': 141,
    },
    'muted': {
      'r': 68,
      'g': 66,
      'b': 103,
    },
    'synKeyword': {
      'r': 130,
      'g': 170,
      'b': 255,
    },
    'synString': {
      'r': 195,
      'g': 232,
      'b': 141,
    },
    'synNumber': {
      'r': 247,
      'g': 140,
      'b': 108,
    },
    'synComment': {
      'r': 103,
      'g': 110,
      'b': 149,
    },
    'synFunction': {
      'r': 130,
      'g': 170,
      'b': 255,
    },
    'synType': {
      'r': 199,
      'g': 146,
      'b': 234,
    },
    'synOperator': {
      'r': 137,
      'g': 221,
      'b': 255,
    },
    'synText': {
      'r': 166,
      'g': 172,
      'b': 205,
    },
    'synPunctuation': {
      'r': 137,
      'g': 221,
      'b': 255,
    },
    'synMeta': {
      'r': 103,
      'g': 110,
      'b': 149,
    },
    'synAtom': {
      'r': 187,
      'g': 128,
      'b': 179,
    },
    'synProperty': {
      'r': 128,
      'g': 203,
      'b': 196,
    },
    'synVariable': {
      'r': 166,
      'g': 172,
      'b': 205,
    },
    'scrollbarTrack': {
      'r': 32,
      'g': 35,
      'b': 49,
    },
    'scrollbarThumb': {
      'r': 62,
      'g': 66,
      'b': 81,
    },
    'scrollbarThumbHover': {
      'r': 77,
      'g': 81,
      'b': 94,
    },
    'ansiBlack': {
      'r': 53,
      'g': 57,
      'b': 73,
    },
    'ansiRed': {
      'r': 255,
      'g': 83,
      'b': 112,
    },
    'ansiGreen': {
      'r': 195,
      'g': 232,
      'b': 141,
    },
    'ansiYellow': {
      'r': 255,
      'g': 203,
      'b': 107,
    },
    'ansiBlue': {
      'r': 199,
      'g': 146,
      'b': 234,
    },
    'ansiMagenta': {
      'r': 130,
      'g': 170,
      'b': 255,
    },
    'ansiCyan': {
      'r': 164,
      'g': 158,
      'b': 244,
    },
    'ansiWhite': {
      'r': 122,
      'g': 127,
      'b': 154,
    },
    'ansiBlackBright': {
      'r': 86,
      'g': 91,
      'b': 112,
    },
    'ansiRedBright': {
      'r': 228,
      'g': 109,
      'b': 139,
    },
    'ansiGreenBright': {
      'r': 186,
      'g': 213,
      'b': 160,
    },
    'ansiYellowBright': {
      'r': 228,
      'g': 193,
      'b': 136,
    },
    'ansiBlueBright': {
      'r': 189,
      'g': 153,
      'b': 225,
    },
    'ansiMagentaBright': {
      'r': 140,
      'g': 170,
      'b': 240,
    },
    'ansiCyanBright': {
      'r': 164,
      'g': 162,
      'b': 232,
    },
    'ansiWhiteBright': {
      'r': 135,
      'g': 140,
      'b': 169,
    },
  }


export const solarizedDarkPalette: ColorPalette =
  {
    'bg': {
      'r': 0,
      'g': 43,
      'b': 54,
    },
    'bgSecondary': {
      'r': 0,
      'g': 37,
      'b': 47,
    },
    'bgTertiary': {
      'r': 15,
      'g': 55,
      'b': 66,
    },
    'bgInput': {
      'r': 10,
      'g': 51,
      'b': 62,
    },
    'bgHover': {
      'r': 153,
      'g': 238,
      'b': 255,
    },
    'bgActive': {
      'r': 25,
      'g': 64,
      'b': 74,
    },
    'border': {
      'r': 25,
      'g': 64,
      'b': 74,
    },
    'borderStrong': {
      'r': 43,
      'g': 79,
      'b': 88,
    },
    'borderSubtle': {
      'r': 24,
      'g': 61,
      'b': 71,
    },
    'text': {
      'r': 147,
      'g': 161,
      'b': 161,
    },
    'textSecondary': {
      'r': 95,
      'g': 119,
      'b': 123,
    },
    'textTertiary': {
      'r': 88,
      'g': 110,
      'b': 117,
    },
    'textInverse': {
      'r': 0,
      'g': 0,
      'b': 0,
    },
    'accent': {
      'r': 38,
      'g': 139,
      'b': 210,
    },
    'accentDim': {
      'r': 30,
      'g': 111,
      'b': 168,
    },
    'accentSecondary': {
      'r': 38,
      'g': 139,
      'b': 210,
    },
    'danger': {
      'r': 220,
      'g': 50,
      'b': 47,
    },
    'warning': {
      'r': 181,
      'g': 137,
      'b': 0,
    },
    'info': {
      'r': 203,
      'g': 75,
      'b': 22,
    },
    'success': {
      'r': 181,
      'g': 137,
      'b': 0,
    },
    'muted': {
      'r': 2,
      'g': 184,
      'b': 255,
    },
    'synKeyword': {
      'r': 133,
      'g': 153,
      'b': 0,
    },
    'synString': {
      'r': 181,
      'g': 137,
      'b': 0,
    },
    'synNumber': {
      'r': 211,
      'g': 54,
      'b': 130,
    },
    'synComment': {
      'r': 88,
      'g': 110,
      'b': 117,
    },
    'synFunction': {
      'r': 38,
      'g': 139,
      'b': 210,
    },
    'synType': {
      'r': 203,
      'g': 75,
      'b': 22,
    },
    'synOperator': {
      'r': 108,
      'g': 113,
      'b': 196,
    },
    'synText': {
      'r': 147,
      'g': 161,
      'b': 161,
    },
    'synPunctuation': {
      'r': 131,
      'g': 148,
      'b': 150,
    },
    'synMeta': {
      'r': 220,
      'g': 50,
      'b': 47,
    },
    'synAtom': {
      'r': 211,
      'g': 54,
      'b': 130,
    },
    'synProperty': {
      'r': 42,
      'g': 161,
      'b': 152,
    },
    'synVariable': {
      'r': 147,
      'g': 161,
      'b': 161,
    },
    'scrollbarTrack': {
      'r': 0,
      'g': 37,
      'b': 47,
    },
    'scrollbarThumb': {
      'r': 25,
      'g': 64,
      'b': 74,
    },
    'scrollbarThumbHover': {
      'r': 43,
      'g': 79,
      'b': 88,
    },
    'ansiBlack': {
      'r': 15,
      'g': 55,
      'b': 66,
    },
    'ansiRed': {
      'r': 220,
      'g': 50,
      'b': 47,
    },
    'ansiGreen': {
      'r': 181,
      'g': 137,
      'b': 0,
    },
    'ansiYellow': {
      'r': 189,
      'g': 151,
      'b': 30,
    },
    'ansiBlue': {
      'r': 203,
      'g': 75,
      'b': 22,
    },
    'ansiMagenta': {
      'r': 38,
      'g': 139,
      'b': 210,
    },
    'ansiCyan': {
      'r': 120,
      'g': 107,
      'b': 116,
    },
    'ansiWhite': {
      'r': 95,
      'g': 119,
      'b': 123,
    },
    'ansiBlackBright': {
      'r': 54,
      'g': 86,
      'b': 94,
    },
    'ansiRedBright': {
      'r': 198,
      'g': 83,
      'b': 81,
    },
    'ansiGreenBright': {
      'r': 170,
      'g': 144,
      'b': 48,
    },
    'ansiYellowBright': {
      'r': 176,
      'g': 154,
      'b': 69,
    },
    'ansiBlueBright': {
      'r': 186,
      'g': 100,
      'b': 63,
    },
    'ansiMagentaBright': {
      'r': 70,
      'g': 145,
      'b': 195,
    },
    'ansiCyanBright': {
      'r': 128,
      'g': 123,
      'b': 129,
    },
    'ansiWhiteBright': {
      'r': 110,
      'g': 131,
      'b': 134,
    },
  }


export const solarizedLightPalette: ColorPalette =
  {
    'bg': {
      'r': 253,
      'g': 246,
      'b': 227,
    },
    'bgSecondary': {
      'r': 223,
      'g': 217,
      'b': 200,
    },
    'bgTertiary': {
      'r': 242,
      'g': 236,
      'b': 217,
    },
    'bgInput': {
      'r': 247,
      'g': 241,
      'b': 222,
    },
    'bgHover': {
      'r': 204,
      'g': 238,
      'b': 255,
    },
    'bgActive': {
      'r': 237,
      'g': 231,
      'b': 213,
    },
    'border': {
      'r': 237,
      'g': 231,
      'b': 213,
    },
    'borderStrong': {
      'r': 225,
      'g': 219,
      'b': 202,
    },
    'borderSubtle': {
      'r': 237,
      'g': 231,
      'b': 213,
    },
    'text': {
      'r': 101,
      'g': 123,
      'b': 131,
    },
    'textSecondary': {
      'r': 154,
      'g': 166,
      'b': 164,
    },
    'textTertiary': {
      'r': 88,
      'g': 110,
      'b': 117,
    },
    'textInverse': {
      'r': 0,
      'g': 0,
      'b': 0,
    },
    'accent': {
      'r': 38,
      'g': 139,
      'b': 210,
    },
    'accentDim': {
      'r': 30,
      'g': 111,
      'b': 168,
    },
    'accentSecondary': {
      'r': 38,
      'g': 139,
      'b': 210,
    },
    'danger': {
      'r': 220,
      'g': 50,
      'b': 47,
    },
    'warning': {
      'r': 181,
      'g': 137,
      'b': 0,
    },
    'info': {
      'r': 203,
      'g': 75,
      'b': 22,
    },
    'success': {
      'r': 181,
      'g': 137,
      'b': 0,
    },
    'muted': {
      'r': 255,
      'g': 208,
      'b': 122,
    },
    'synKeyword': {
      'r': 133,
      'g': 153,
      'b': 0,
    },
    'synString': {
      'r': 181,
      'g': 137,
      'b': 0,
    },
    'synNumber': {
      'r': 211,
      'g': 54,
      'b': 130,
    },
    'synComment': {
      'r': 88,
      'g': 110,
      'b': 117,
    },
    'synFunction': {
      'r': 38,
      'g': 139,
      'b': 210,
    },
    'synType': {
      'r': 203,
      'g': 75,
      'b': 22,
    },
    'synOperator': {
      'r': 108,
      'g': 113,
      'b': 196,
    },
    'synText': {
      'r': 101,
      'g': 123,
      'b': 131,
    },
    'synPunctuation': {
      'r': 88,
      'g': 110,
      'b': 117,
    },
    'synMeta': {
      'r': 220,
      'g': 50,
      'b': 47,
    },
    'synAtom': {
      'r': 211,
      'g': 54,
      'b': 130,
    },
    'synProperty': {
      'r': 42,
      'g': 161,
      'b': 152,
    },
    'synVariable': {
      'r': 101,
      'g': 123,
      'b': 131,
    },
    'scrollbarTrack': {
      'r': 223,
      'g': 217,
      'b': 200,
    },
    'scrollbarThumb': {
      'r': 237,
      'g': 231,
      'b': 213,
    },
    'scrollbarThumbHover': {
      'r': 225,
      'g': 219,
      'b': 202,
    },
    'ansiBlack': {
      'r': 242,
      'g': 236,
      'b': 217,
    },
    'ansiRed': {
      'r': 220,
      'g': 50,
      'b': 47,
    },
    'ansiGreen': {
      'r': 181,
      'g': 137,
      'b': 0,
    },
    'ansiYellow': {
      'r': 159,
      'g': 120,
      'b': 0,
    },
    'ansiBlue': {
      'r': 203,
      'g': 75,
      'b': 22,
    },
    'ansiMagenta': {
      'r': 38,
      'g': 139,
      'b': 210,
    },
    'ansiCyan': {
      'r': 120,
      'g': 107,
      'b': 116,
    },
    'ansiWhite': {
      'r': 154,
      'g': 166,
      'b': 164,
    },
    'ansiBlackBright': {
      'r': 199,
      'g': 202,
      'b': 191,
    },
    'ansiRedBright': {
      'r': 184,
      'g': 71,
      'b': 72,
    },
    'ansiGreenBright': {
      'r': 157,
      'g': 132,
      'b': 39,
    },
    'ansiYellowBright': {
      'r': 141,
      'g': 120,
      'b': 39,
    },
    'ansiBlueBright': {
      'r': 172,
      'g': 89,
      'b': 54,
    },
    'ansiMagentaBright': {
      'r': 56,
      'g': 134,
      'b': 186,
    },
    'ansiCyanBright': {
      'r': 114,
      'g': 111,
      'b': 120,
    },
    'ansiWhiteBright': {
      'r': 138,
      'g': 153,
      'b': 154,
    },
  }


export const synthwave84Palette: ColorPalette =
  {
    'bg': {
      'r': 38,
      'g': 35,
      'b': 53,
    },
    'bgSecondary': {
      'r': 36,
      'g': 27,
      'b': 47,
    },
    'bgTertiary': {
      'r': 51,
      'g': 48,
      'b': 65,
    },
    'bgInput': {
      'r': 46,
      'g': 43,
      'b': 61,
    },
    'bgHover': {
      'r': 42,
      'g': 33,
      'b': 57,
    },
    'bgActive': {
      'r': 59,
      'g': 57,
      'b': 73,
    },
    'border': {
      'r': 59,
      'g': 57,
      'b': 73,
    },
    'borderStrong': {
      'r': 74,
      'g': 72,
      'b': 87,
    },
    'borderSubtle': {
      'r': 56,
      'g': 54,
      'b': 70,
    },
    'text': {
      'r': 255,
      'g': 255,
      'b': 255,
    },
    'textSecondary': {
      'r': 179,
      'g': 178,
      'b': 184,
    },
    'textTertiary': {
      'r': 73,
      'g': 84,
      'b': 149,
    },
    'textInverse': {
      'r': 0,
      'g': 0,
      'b': 0,
    },
    'accent': {
      'r': 255,
      'g': 126,
      'b': 219,
    },
    'accentDim': {
      'r': 204,
      'g': 100,
      'b': 175,
    },
    'accentSecondary': {
      'r': 114,
      'g': 241,
      'b': 184,
    },
    'danger': {
      'r': 254,
      'g': 68,
      'b': 80,
    },
    'warning': {
      'r': 254,
      'g': 222,
      'b': 93,
    },
    'info': {
      'r': 254,
      'g': 222,
      'b': 93,
    },
    'success': {
      'r': 114,
      'g': 241,
      'b': 184,
    },
    'muted': {
      'r': 52,
      'g': 41,
      'b': 79,
    },
    'synKeyword': {
      'r': 255,
      'g': 126,
      'b': 219,
    },
    'synString': {
      'r': 114,
      'g': 241,
      'b': 184,
    },
    'synNumber': {
      'r': 249,
      'g': 126,
      'b': 114,
    },
    'synComment': {
      'r': 73,
      'g': 84,
      'b': 149,
    },
    'synFunction': {
      'r': 114,
      'g': 241,
      'b': 184,
    },
    'synType': {
      'r': 254,
      'g': 222,
      'b': 93,
    },
    'synOperator': {
      'r': 114,
      'g': 241,
      'b': 184,
    },
    'synText': {
      'r': 255,
      'g': 255,
      'b': 255,
    },
    'synPunctuation': {
      'r': 132,
      'g': 139,
      'b': 189,
    },
    'synMeta': {
      'r': 73,
      'g': 84,
      'b': 149,
    },
    'synAtom': {
      'r': 249,
      'g': 126,
      'b': 114,
    },
    'synProperty': {
      'r': 54,
      'g': 249,
      'b': 246,
    },
    'synVariable': {
      'r': 255,
      'g': 255,
      'b': 255,
    },
    'scrollbarTrack': {
      'r': 36,
      'g': 27,
      'b': 47,
    },
    'scrollbarThumb': {
      'r': 59,
      'g': 57,
      'b': 73,
    },
    'scrollbarThumbHover': {
      'r': 74,
      'g': 72,
      'b': 87,
    },
    'ansiBlack': {
      'r': 51,
      'g': 48,
      'b': 65,
    },
    'ansiRed': {
      'r': 254,
      'g': 68,
      'b': 80,
    },
    'ansiGreen': {
      'r': 114,
      'g': 241,
      'b': 184,
    },
    'ansiYellow': {
      'r': 254,
      'g': 222,
      'b': 93,
    },
    'ansiBlue': {
      'r': 254,
      'g': 225,
      'b': 112,
    },
    'ansiMagenta': {
      'r': 130,
      'g': 242,
      'b': 192,
    },
    'ansiCyan': {
      'r': 254,
      'g': 174,
      'b': 156,
    },
    'ansiWhite': {
      'r': 179,
      'g': 178,
      'b': 184,
    },
    'ansiBlackBright': {
      'r': 112,
      'g': 110,
      'b': 122,
    },
    'ansiRedBright': {
      'r': 254,
      'g': 124,
      'b': 132,
    },
    'ansiGreenBright': {
      'r': 156,
      'g': 245,
      'b': 205,
    },
    'ansiYellowBright': {
      'r': 254,
      'g': 231,
      'b': 141,
    },
    'ansiBlueBright': {
      'r': 254,
      'g': 234,
      'b': 154,
    },
    'ansiMagentaBright': {
      'r': 167,
      'g': 245,
      'b': 210,
    },
    'ansiCyanBright': {
      'r': 254,
      'g': 198,
      'b': 185,
    },
    'ansiWhiteBright': {
      'r': 201,
      'g': 201,
      'b': 205,
    },
  }


export const tokyoNightDayPalette: ColorPalette =
  {
    'bg': {
      'r': 225,
      'g': 226,
      'b': 231,
    },
    'bgSecondary': {
      'r': 213,
      'g': 214,
      'b': 219,
    },
    'bgTertiary': {
      'r': 216,
      'g': 216,
      'b': 221,
    },
    'bgInput': {
      'r': 220,
      'g': 221,
      'b': 226,
    },
    'bgHover': {
      'r': 95,
      'g': 95,
      'b': 175,
    },
    'bgActive': {
      'r': 211,
      'g': 212,
      'b': 217,
    },
    'border': {
      'r': 211,
      'g': 212,
      'b': 217,
    },
    'borderStrong': {
      'r': 200,
      'g': 201,
      'b': 206,
    },
    'borderSubtle': {
      'r': 211,
      'g': 212,
      'b': 217,
    },
    'text': {
      'r': 55,
      'g': 96,
      'b': 191,
    },
    'textSecondary': {
      'r': 114,
      'g': 141,
      'b': 205,
    },
    'textTertiary': {
      'r': 132,
      'g': 140,
      'b': 181,
    },
    'textInverse': {
      'r': 255,
      'g': 255,
      'b': 255,
    },
    'accent': {
      'r': 0,
      'g': 113,
      'b': 151,
    },
    'accentDim': {
      'r': 0,
      'g': 90,
      'b': 120,
    },
    'accentSecondary': {
      'r': 0,
      'g': 113,
      'b': 151,
    },
    'danger': {
      'r': 245,
      'g': 42,
      'b': 101,
    },
    'warning': {
      'r': 177,
      'g': 92,
      'b': 0,
    },
    'info': {
      'r': 0,
      'g': 113,
      'b': 151,
    },
    'success': {
      'r': 88,
      'g': 117,
      'b': 57,
    },
    'muted': {
      'r': 153,
      'g': 167,
      'b': 223,
    },
    'synKeyword': {
      'r': 0,
      'g': 113,
      'b': 151,
    },
    'synString': {
      'r': 88,
      'g': 117,
      'b': 57,
    },
    'synNumber': {
      'r': 177,
      'g': 92,
      'b': 0,
    },
    'synComment': {
      'r': 132,
      'g': 140,
      'b': 181,
    },
    'synFunction': {
      'r': 0,
      'g': 113,
      'b': 151,
    },
    'synType': {
      'r': 0,
      'g': 113,
      'b': 151,
    },
    'synOperator': {
      'r': 120,
      'g': 71,
      'b': 189,
    },
    'synText': {
      'r': 55,
      'g': 96,
      'b': 191,
    },
    'synPunctuation': {
      'r': 132,
      'g': 140,
      'b': 181,
    },
    'synMeta': {
      'r': 132,
      'g': 140,
      'b': 181,
    },
    'synAtom': {
      'r': 177,
      'g': 92,
      'b': 0,
    },
    'synProperty': {
      'r': 46,
      'g': 125,
      'b': 233,
    },
    'synVariable': {
      'r': 55,
      'g': 96,
      'b': 191,
    },
    'scrollbarTrack': {
      'r': 213,
      'g': 214,
      'b': 219,
    },
    'scrollbarThumb': {
      'r': 211,
      'g': 212,
      'b': 217,
    },
    'scrollbarThumbHover': {
      'r': 200,
      'g': 201,
      'b': 206,
    },
    'ansiBlack': {
      'r': 216,
      'g': 216,
      'b': 221,
    },
    'ansiRed': {
      'r': 245,
      'g': 42,
      'b': 101,
    },
    'ansiGreen': {
      'r': 88,
      'g': 117,
      'b': 57,
    },
    'ansiYellow': {
      'r': 177,
      'g': 92,
      'b': 0,
    },
    'ansiBlue': {
      'r': 0,
      'g': 113,
      'b': 151,
    },
    'ansiMagenta': {
      'r': 0,
      'g': 99,
      'b': 132,
    },
    'ansiCyan': {
      'r': 0,
      'g': 87,
      'b': 116,
    },
    'ansiWhite': {
      'r': 114,
      'g': 141,
      'b': 205,
    },
    'ansiBlackBright': {
      'r': 167,
      'g': 180,
      'b': 212,
    },
    'ansiRedBright': {
      'r': 188,
      'g': 58,
      'b': 127,
    },
    'ansiGreenBright': {
      'r': 78,
      'g': 110,
      'b': 97,
    },
    'ansiYellowBright': {
      'r': 140,
      'g': 93,
      'b': 57,
    },
    'ansiBlueBright': {
      'r': 16,
      'g': 107,
      'b': 163,
    },
    'ansiMagentaBright': {
      'r': 16,
      'g': 98,
      'b': 149,
    },
    'ansiCyanBright': {
      'r': 16,
      'g': 89,
      'b': 138,
    },
    'ansiWhiteBright': {
      'r': 96,
      'g': 127,
      'b': 200,
    },
  }


export const tokyoNightStormPalette: ColorPalette =
  {
    'bg': {
      'r': 36,
      'g': 40,
      'b': 59,
    },
    'bgSecondary': {
      'r': 31,
      'g': 35,
      'b': 53,
    },
    'bgTertiary': {
      'r': 49,
      'g': 52,
      'b': 70,
    },
    'bgInput': {
      'r': 44,
      'g': 48,
      'b': 66,
    },
    'bgHover': {
      'r': 41,
      'g': 46,
      'b': 66,
    },
    'bgActive': {
      'r': 57,
      'g': 61,
      'b': 78,
    },
    'border': {
      'r': 57,
      'g': 61,
      'b': 78,
    },
    'borderStrong': {
      'r': 72,
      'g': 76,
      'b': 92,
    },
    'borderSubtle': {
      'r': 54,
      'g': 58,
      'b': 74,
    },
    'text': {
      'r': 192,
      'g': 202,
      'b': 245,
    },
    'textSecondary': {
      'r': 137,
      'g': 145,
      'b': 179,
    },
    'textTertiary': {
      'r': 86,
      'g': 95,
      'b': 137,
    },
    'textInverse': {
      'r': 0,
      'g': 0,
      'b': 0,
    },
    'accent': {
      'r': 122,
      'g': 162,
      'b': 247,
    },
    'accentDim': {
      'r': 97,
      'g': 129,
      'b': 197,
    },
    'accentSecondary': {
      'r': 122,
      'g': 162,
      'b': 247,
    },
    'danger': {
      'r': 247,
      'g': 118,
      'b': 142,
    },
    'warning': {
      'r': 255,
      'g': 158,
      'b': 100,
    },
    'info': {
      'r': 42,
      'g': 195,
      'b': 222,
    },
    'success': {
      'r': 158,
      'g': 206,
      'b': 106,
    },
    'muted': {
      'r': 111,
      'g': 123,
      'b': 182,
    },
    'synKeyword': {
      'r': 187,
      'g': 154,
      'b': 247,
    },
    'synString': {
      'r': 158,
      'g': 206,
      'b': 106,
    },
    'synNumber': {
      'r': 255,
      'g': 158,
      'b': 100,
    },
    'synComment': {
      'r': 86,
      'g': 95,
      'b': 137,
    },
    'synFunction': {
      'r': 122,
      'g': 162,
      'b': 247,
    },
    'synType': {
      'r': 42,
      'g': 195,
      'b': 222,
    },
    'synOperator': {
      'r': 187,
      'g': 154,
      'b': 247,
    },
    'synText': {
      'r': 192,
      'g': 202,
      'b': 245,
    },
    'synPunctuation': {
      'r': 86,
      'g': 95,
      'b': 137,
    },
    'synMeta': {
      'r': 86,
      'g': 95,
      'b': 137,
    },
    'synAtom': {
      'r': 255,
      'g': 158,
      'b': 100,
    },
    'synProperty': {
      'r': 122,
      'g': 162,
      'b': 247,
    },
    'synVariable': {
      'r': 192,
      'g': 202,
      'b': 245,
    },
    'scrollbarTrack': {
      'r': 31,
      'g': 35,
      'b': 53,
    },
    'scrollbarThumb': {
      'r': 57,
      'g': 61,
      'b': 78,
    },
    'scrollbarThumbHover': {
      'r': 72,
      'g': 76,
      'b': 92,
    },
    'ansiBlack': {
      'r': 49,
      'g': 52,
      'b': 70,
    },
    'ansiRed': {
      'r': 247,
      'g': 118,
      'b': 142,
    },
    'ansiGreen': {
      'r': 158,
      'g': 206,
      'b': 106,
    },
    'ansiYellow': {
      'r': 255,
      'g': 158,
      'b': 100,
    },
    'ansiBlue': {
      'r': 42,
      'g': 195,
      'b': 222,
    },
    'ansiMagenta': {
      'r': 122,
      'g': 162,
      'b': 247,
    },
    'ansiCyan': {
      'r': 82,
      'g': 178,
      'b': 234,
    },
    'ansiWhite': {
      'r': 137,
      'g': 145,
      'b': 179,
    },
    'ansiBlackBright': {
      'r': 91,
      'g': 97,
      'b': 122,
    },
    'ansiRedBright': {
      'r': 230,
      'g': 143,
      'b': 172,
    },
    'ansiGreenBright': {
      'r': 168,
      'g': 204,
      'b': 147,
    },
    'ansiYellowBright': {
      'r': 236,
      'g': 171,
      'b': 143,
    },
    'ansiBlueBright': {
      'r': 87,
      'g': 197,
      'b': 228,
    },
    'ansiMagentaBright': {
      'r': 143,
      'g': 174,
      'b': 246,
    },
    'ansiCyanBright': {
      'r': 115,
      'g': 185,
      'b': 237,
    },
    'ansiWhiteBright': {
      'r': 153,
      'g': 162,
      'b': 198,
    },
  }


export const volcanoPalette: ColorPalette =
  {
    'bg': {
      'r': 57,
      'g': 0,
      'b': 0,
    },
    'bgSecondary': {
      'r': 74,
      'g': 0,
      'b': 0,
    },
    'bgTertiary': {
      'r': 68,
      'g': 15,
      'b': 15,
    },
    'bgInput': {
      'r': 64,
      'g': 10,
      'b': 10,
    },
    'bgHover': {
      'r': 255,
      'g': 0,
      'b': 0,
    },
    'bgActive': {
      'r': 76,
      'g': 25,
      'b': 25,
    },
    'border': {
      'r': 76,
      'g': 25,
      'b': 25,
    },
    'borderStrong': {
      'r': 90,
      'g': 43,
      'b': 43,
    },
    'borderSubtle': {
      'r': 72,
      'g': 24,
      'b': 24,
    },
    'text': {
      'r': 248,
      'g': 248,
      'b': 248,
    },
    'textSecondary': {
      'r': 181,
      'g': 161,
      'b': 161,
    },
    'textTertiary': {
      'r': 231,
      'g': 192,
      'b': 192,
    },
    'textInverse': {
      'r': 255,
      'g': 255,
      'b': 255,
    },
    'accent': {
      'r': 241,
      'g': 39,
      'b': 39,
    },
    'accentDim': {
      'r': 192,
      'g': 31,
      'b': 31,
    },
    'accentSecondary': {
      'r': 125,
      'g': 243,
      'b': 247,
    },
    'danger': {
      'r': 236,
      'g': 13,
      'b': 30,
    },
    'warning': {
      'r': 170,
      'g': 85,
      'b': 7,
    },
    'info': {
      'r': 157,
      'g': 243,
      'b': 159,
    },
    'success': {
      'r': 254,
      'g': 199,
      'b': 88,
    },
    'muted': {
      'r': 117,
      'g': 0,
      'b': 0,
    },
    'synKeyword': {
      'r': 241,
      'g': 39,
      'b': 39,
    },
    'synString': {
      'r': 254,
      'g': 199,
      'b': 88,
    },
    'synNumber': {
      'r': 170,
      'g': 85,
      'b': 7,
    },
    'synComment': {
      'r': 231,
      'g': 192,
      'b': 192,
    },
    'synFunction': {
      'r': 125,
      'g': 243,
      'b': 247,
    },
    'synType': {
      'r': 157,
      'g': 243,
      'b': 159,
    },
    'synOperator': {
      'r': 194,
      'g': 125,
      'b': 247,
    },
    'synText': {
      'r': 248,
      'g': 248,
      'b': 248,
    },
    'synPunctuation': {
      'r': 231,
      'g': 192,
      'b': 192,
    },
    'synMeta': {
      'r': 231,
      'g': 192,
      'b': 192,
    },
    'synAtom': {
      'r': 170,
      'g': 85,
      'b': 7,
    },
    'synProperty': {
      'r': 125,
      'g': 243,
      'b': 247,
    },
    'synVariable': {
      'r': 254,
      'g': 199,
      'b': 88,
    },
    'scrollbarTrack': {
      'r': 74,
      'g': 0,
      'b': 0,
    },
    'scrollbarThumb': {
      'r': 76,
      'g': 25,
      'b': 25,
    },
    'scrollbarThumbHover': {
      'r': 90,
      'g': 43,
      'b': 43,
    },
    'ansiBlack': {
      'r': 68,
      'g': 15,
      'b': 15,
    },
    'ansiRed': {
      'r': 236,
      'g': 13,
      'b': 30,
    },
    'ansiGreen': {
      'r': 254,
      'g': 199,
      'b': 88,
    },
    'ansiYellow': {
      'r': 170,
      'g': 85,
      'b': 7,
    },
    'ansiBlue': {
      'r': 157,
      'g': 243,
      'b': 159,
    },
    'ansiMagenta': {
      'r': 125,
      'g': 243,
      'b': 247,
    },
    'ansiCyan': {
      'r': 199,
      'g': 141,
      'b': 99,
    },
    'ansiWhite': {
      'r': 181,
      'g': 161,
      'b': 161,
    },
    'ansiBlackBright': {
      'r': 121,
      'g': 84,
      'b': 84,
    },
    'ansiRedBright': {
      'r': 239,
      'g': 83,
      'b': 95,
    },
    'ansiGreenBright': {
      'r': 252,
      'g': 213,
      'b': 136,
    },
    'ansiYellowBright': {
      'r': 193,
      'g': 133,
      'b': 79,
    },
    'ansiBlueBright': {
      'r': 184,
      'g': 244,
      'b': 185,
    },
    'ansiMagentaBright': {
      'r': 161,
      'g': 244,
      'b': 247,
    },
    'ansiCyanBright': {
      'r': 213,
      'g': 173,
      'b': 143,
    },
    'ansiWhiteBright': {
      'r': 201,
      'g': 187,
      'b': 187,
    },
  }


export const vscodeDarkPalette: ColorPalette =
  {
    'bg': {
      'r': 30,
      'g': 30,
      'b': 30,
    },
    'bgSecondary': {
      'r': 28,
      'g': 28,
      'b': 28,
    },
    'bgTertiary': {
      'r': 43,
      'g': 43,
      'b': 43,
    },
    'bgInput': {
      'r': 39,
      'g': 39,
      'b': 39,
    },
    'bgHover': {
      'r': 255,
      'g': 255,
      'b': 255,
    },
    'bgActive': {
      'r': 52,
      'g': 52,
      'b': 52,
    },
    'border': {
      'r': 52,
      'g': 52,
      'b': 52,
    },
    'borderStrong': {
      'r': 68,
      'g': 68,
      'b': 68,
    },
    'borderSubtle': {
      'r': 49,
      'g': 49,
      'b': 49,
    },
    'text': {
      'r': 212,
      'g': 212,
      'b': 212,
    },
    'textSecondary': {
      'r': 148,
      'g': 148,
      'b': 148,
    },
    'textTertiary': {
      'r': 131,
      'g': 131,
      'b': 131,
    },
    'textInverse': {
      'r': 0,
      'g': 0,
      'b': 0,
    },
    'accent': {
      'r': 86,
      'g': 156,
      'b': 214,
    },
    'accentDim': {
      'r': 68,
      'g': 124,
      'b': 171,
    },
    'accentSecondary': {
      'r': 220,
      'g': 220,
      'b': 170,
    },
    'danger': {
      'r': 244,
      'g': 71,
      'b': 71,
    },
    'warning': {
      'r': 215,
      'g': 186,
      'b': 125,
    },
    'info': {
      'r': 78,
      'g': 201,
      'b': 176,
    },
    'success': {
      'r': 206,
      'g': 145,
      'b': 120,
    },
    'muted': {
      'r': 38,
      'g': 79,
      'b': 120,
    },
    'synKeyword': {
      'r': 86,
      'g': 156,
      'b': 214,
    },
    'synString': {
      'r': 206,
      'g': 145,
      'b': 120,
    },
    'synNumber': {
      'r': 181,
      'g': 206,
      'b': 168,
    },
    'synComment': {
      'r': 106,
      'g': 153,
      'b': 85,
    },
    'synFunction': {
      'r': 220,
      'g': 220,
      'b': 170,
    },
    'synType': {
      'r': 78,
      'g': 201,
      'b': 176,
    },
    'synOperator': {
      'r': 212,
      'g': 212,
      'b': 212,
    },
    'synText': {
      'r': 212,
      'g': 212,
      'b': 212,
    },
    'synPunctuation': {
      'r': 212,
      'g': 212,
      'b': 212,
    },
    'synMeta': {
      'r': 131,
      'g': 131,
      'b': 131,
    },
    'synAtom': {
      'r': 86,
      'g': 156,
      'b': 214,
    },
    'synProperty': {
      'r': 156,
      'g': 220,
      'b': 254,
    },
    'synVariable': {
      'r': 156,
      'g': 220,
      'b': 254,
    },
    'scrollbarTrack': {
      'r': 28,
      'g': 28,
      'b': 28,
    },
    'scrollbarThumb': {
      'r': 52,
      'g': 52,
      'b': 52,
    },
    'scrollbarThumbHover': {
      'r': 68,
      'g': 68,
      'b': 68,
    },
    'ansiBlack': {
      'r': 43,
      'g': 43,
      'b': 43,
    },
    'ansiRed': {
      'r': 244,
      'g': 71,
      'b': 71,
    },
    'ansiGreen': {
      'r': 206,
      'g': 145,
      'b': 120,
    },
    'ansiYellow': {
      'r': 215,
      'g': 186,
      'b': 125,
    },
    'ansiBlue': {
      'r': 78,
      'g': 201,
      'b': 176,
    },
    'ansiMagenta': {
      'r': 220,
      'g': 220,
      'b': 170,
    },
    'ansiCyan': {
      'r': 82,
      'g': 178,
      'b': 195,
    },
    'ansiWhite': {
      'r': 148,
      'g': 148,
      'b': 148,
    },
    'ansiBlackBright': {
      'r': 93,
      'g': 93,
      'b': 93,
    },
    'ansiRedBright': {
      'r': 234,
      'g': 113,
      'b': 113,
    },
    'ansiGreenBright': {
      'r': 207,
      'g': 165,
      'b': 147,
    },
    'ansiYellowBright': {
      'r': 214,
      'g': 193,
      'b': 151,
    },
    'ansiBlueBright': {
      'r': 118,
      'g': 204,
      'b': 186,
    },
    'ansiMagentaBright': {
      'r': 217,
      'g': 217,
      'b': 182,
    },
    'ansiCyanBright': {
      'r': 121,
      'g': 188,
      'b': 200,
    },
    'ansiWhiteBright': {
      'r': 167,
      'g': 167,
      'b': 167,
    },
  }


export const vscodeLightPalette: ColorPalette =
  {
    'bg': {
      'r': 255,
      'g': 255,
      'b': 255,
    },
    'bgSecondary': {
      'r': 245,
      'g': 245,
      'b': 245,
    },
    'bgTertiary': {
      'r': 244,
      'g': 244,
      'b': 244,
    },
    'bgInput': {
      'r': 249,
      'g': 249,
      'b': 249,
    },
    'bgHover': {
      'r': 153,
      'g': 153,
      'b': 153,
    },
    'bgActive': {
      'r': 239,
      'g': 239,
      'b': 239,
    },
    'border': {
      'r': 239,
      'g': 239,
      'b': 239,
    },
    'borderStrong': {
      'r': 227,
      'g': 227,
      'b': 227,
    },
    'borderSubtle': {
      'r': 239,
      'g': 239,
      'b': 239,
    },
    'text': {
      'r': 56,
      'g': 58,
      'b': 66,
    },
    'textSecondary': {
      'r': 125,
      'g': 126,
      'b': 132,
    },
    'textTertiary': {
      'r': 35,
      'g': 120,
      'b': 147,
    },
    'textInverse': {
      'r': 255,
      'g': 255,
      'b': 255,
    },
    'accent': {
      'r': 0,
      'g': 100,
      'b': 255,
    },
    'accentDim': {
      'r': 0,
      'g': 80,
      'b': 204,
    },
    'accentSecondary': {
      'r': 121,
      'g': 94,
      'b': 38,
    },
    'danger': {
      'r': 229,
      'g': 20,
      'b': 0,
    },
    'warning': {
      'r': 191,
      'g': 136,
      'b': 3,
    },
    'info': {
      'r': 38,
      'g': 127,
      'b': 153,
    },
    'success': {
      'r': 163,
      'g': 21,
      'b': 21,
    },
    'muted': {
      'r': 173,
      'g': 214,
      'b': 255,
    },
    'synKeyword': {
      'r': 0,
      'g': 100,
      'b': 255,
    },
    'synString': {
      'r': 163,
      'g': 21,
      'b': 21,
    },
    'synNumber': {
      'r': 9,
      'g': 134,
      'b': 88,
    },
    'synComment': {
      'r': 0,
      'g': 128,
      'b': 0,
    },
    'synFunction': {
      'r': 121,
      'g': 94,
      'b': 38,
    },
    'synType': {
      'r': 38,
      'g': 127,
      'b': 153,
    },
    'synOperator': {
      'r': 56,
      'g': 58,
      'b': 66,
    },
    'synText': {
      'r': 56,
      'g': 58,
      'b': 66,
    },
    'synPunctuation': {
      'r': 56,
      'g': 58,
      'b': 66,
    },
    'synMeta': {
      'r': 107,
      'g': 107,
      'b': 107,
    },
    'synAtom': {
      'r': 0,
      'g': 100,
      'b': 255,
    },
    'synProperty': {
      'r': 0,
      'g': 112,
      'b': 193,
    },
    'synVariable': {
      'r': 0,
      'g': 112,
      'b': 193,
    },
    'scrollbarTrack': {
      'r': 245,
      'g': 245,
      'b': 245,
    },
    'scrollbarThumb': {
      'r': 239,
      'g': 239,
      'b': 239,
    },
    'scrollbarThumbHover': {
      'r': 227,
      'g': 227,
      'b': 227,
    },
    'ansiBlack': {
      'r': 244,
      'g': 244,
      'b': 244,
    },
    'ansiRed': {
      'r': 229,
      'g': 20,
      'b': 0,
    },
    'ansiGreen': {
      'r': 163,
      'g': 21,
      'b': 21,
    },
    'ansiYellow': {
      'r': 191,
      'g': 136,
      'b': 3,
    },
    'ansiBlue': {
      'r': 38,
      'g': 127,
      'b': 153,
    },
    'ansiMagenta': {
      'r': 121,
      'g': 94,
      'b': 38,
    },
    'ansiCyan': {
      'r': 19,
      'g': 113,
      'b': 204,
    },
    'ansiWhite': {
      'r': 125,
      'g': 126,
      'b': 132,
    },
    'ansiBlackBright': {
      'r': 187,
      'g': 188,
      'b': 190,
    },
    'ansiRedBright': {
      'r': 177,
      'g': 31,
      'b': 19,
    },
    'ansiGreenBright': {
      'r': 130,
      'g': 32,
      'b': 34,
    },
    'ansiYellowBright': {
      'r': 150,
      'g': 112,
      'b': 21,
    },
    'ansiBlueBright': {
      'r': 43,
      'g': 106,
      'b': 126,
    },
    'ansiMagentaBright': {
      'r': 101,
      'g': 83,
      'b': 46,
    },
    'ansiCyanBright': {
      'r': 30,
      'g': 96,
      'b': 162,
    },
    'ansiWhiteBright': {
      'r': 104,
      'g': 105,
      'b': 112,
    },
  }


export const allThemes: Set<Theme> =
  new Set(['customDark', 'customLight', 'abcdef', 'abyss', 'androidStudio', 'andromeda', 'basicDark', 'basicLight', 'catppuccinMocha', 'cobalt2', 'forest', 'githubDark', 'githubLight', 'gruvboxDark', 'gruvboxLight', 'highContrastDark', 'highContrastLight', 'materialDark', 'materialLight', 'materialOcean', 'monokai', 'nord', 'palenight', 'solarizedDark', 'solarizedLight', 'synthwave84', 'tokyoNightDay', 'tokyoNightStorm', 'volcano', 'vscodeDark', 'vscodeLight'])


export const allFonts: Set<Font> =
  new Set(['dejavuMono', 'jetbrainsMono', 'firaCode', 'ibmPlexMono', 'iosevka', 'cascadiaCode', 'hack', 'sourceCodePro'])


export const allAdvancedColorModes: Set<AdvancedColorMode> =
  new Set(['derived', 'custom'])

//# sourceMappingURL=theme.ts.map
